export default {
    "accountValidateMsg" : "Konto musi zawierać od 6 do 30 znaków, w tym litery, cyfry i symbole (\".\", \"_\", \"@\"). Pierwszy znak musi być cyfrą lub literą.",
    "storeSuccess" : "Pomyślne doładowanie",
    "editAccountTips" : "Proszę wprowadzić prawidłową nazwę konta",
    "editPwdTips" : "Proszę wprowadzić prawidłowe hasło",
    "editRepeatPwdTips" : "Proszę ponownie wprowadzić hasło",
    "pwdRepeatTips" : "Hasła nie są zgodne",
    "changePwdSucc" : "Twoje hasło zostało zmienione",
    "bindEmail" : "Powiąż Email",
    "errorVrifyCodeTips" : "błąd kodu weryfikacyjnego",
    "slectQuessionTips" : "Proszę wybrać pytanie bezpieczeństwa",
    "answerTips" : "Proszę wpisać odpowiedź",
    "twoAnswerTips" : "Proszę wybrać utworzone pytania bezpieczeństwa i wprowadzić prawidłowe odpowiedzi",
    "realNameValidateTips" : "Prawdziwe imię i nazwisko (od 4 do 60 znaków)",
    "phoneValidateTips" : "Numer telefonu (od 6 do 18 cyfr)",
    "areaSelectTips" : "Proszę wybrać region",
    "iDCardValidataTips" : "Numer telefonu (od 1 do 60 cyfr)",
    "changeProfileSucc" : "Zapisane zaktualizowane informacje",
    "editVrfCodeTips" : "Wpisz kod weryfikacyjny",
    "securityQuestionTips" : "Proszę utworzyć pytania bezpieczeństwa, aby zwiększyć bezpieczeństwo swojego konta. Gdy zapomnisz hasła, możesz odpowiedzieć na pytania, aby zresetować hasło.",
    "validateQuessionTips" : "Proszę wybrać dwa różne pytania i dokonać weryfikacji. Po weryfikacji możesz odtworzyć pytania.",
    "originPwd" : "Hasło pierwotne",
    "newPwd" : "Nowe hasło",
    "changePwdSuccess" : "Hasło zostało zmienione. Sugerujemy ponowne zalogowanie się w tej chwili, aby zachować swoje postępy.",
    "accountName" : "Nazwa konta",
    "password" : "Wpisz swoje hasło",
    "repeatPassword" : "Proszę powtórzyć swoje hasło",
    "findPwdTips" : "Proszę wprowadzić konto, z którego chcesz odzyskać hasło",
    "submit" : "prześlij",
    "send" : "Wyślij",
    "modify" : "modyfikuj",
    "haveAgree" : "Zgoda",
    "and" : "i",
    "privacyPolicy" : "Polityka Prywatności",
    "completeness" : "Ukończenie",
    "gender" : "Płeć",
    "male" : "mężczyzna",
    "female" : "kobieta",
    "birthday" : "Urodziny",
    "phone" : "Telefon",
    "region" : "Region",
    "ID" : "ID",
    "accountSetting" : "Ustawienia Konta",
    "upgrade" : "Aktualizuj",
    "profile" : "Profil",
    "changePassword" : "Zmień Hasło",
    "securityQuestion" : "Pytania Bezpieczeństwa",
    "creatework_headerTitle" : "Utwórz bilet",
    "mylist_headerTitle" : "Mój bilet",
    "bindEmailTips" : "Zweryfikuj swój adres e-mail dla bezpieczeństwa swojego konta. Jeśli zapomniałeś hasła, wyślemy Ci wiadomość na ten adres.",
    "enterEmailVrfcationTips" : "Proszę wpisać tutaj kod weryfikacyjny.",
    "cancel" : "ANULUJ",
    "bindTps" : "Powiąż swoje konto, aby grać w grę na wielu urządzeniach!",
    "login" : "Zaloguj",
    "logout" : "wyloguj",
    "bind" : "Powiąż konto",
    "feedback" : "Informacje zwrotne",
    "terms" : "Umowy",
    "tips" : "Uwaga",
    "debindTips" : "Odwiązanie może spowodować utratę danych. Czy na pewno chcesz usunąć wiązanie?",
    "debindText" : "Odwiąż",
    "guestSwitchTips" : "Wykryto konto gościa. Po zalogowaniu, dane konta gościa zostaną utracone. Kontynuować?",
    "register" : "zarejestruj się",
    "realName" : "realName",
    "enterEmailTips" : "Wpisz swój adres e-mail",
    "emailVAlidateMsg" : "nieprawidłowy email",
    "editEmaileTips" : "Wpisz swój adres email",
    "checkServiceTips" : "Proszę najpierw zapoznać się z Warunkami użytkowania i Polityką prywatności.",
    "brithdayValidateTips" : "Wpisz datę urodzenia",
    "facebookValidateTips" : "Konto na Facebooku (1 do 60 znaków)",
    "eritOriginPwdTips" : "Pierwotne hasło",
    "submitSuccess" : "Przesłano",
    "rebindEmail" : "Zmień powiązany e-mail",
    "bindEmailSuccess" : "Powiązany e-mail: \$email</br>Proszę użyć powiązanego adresu e-mail do weryfikacji. Możesz zresetować swój e-mail po weryfikacji.",
    "reSetSecurityQuessoon" : "Pomyślnie utworzyłeś pytania bezpieczeństwa </br></br>Proszę wybrać inne pytania i zweryfikować. Możesz odtworzyć pytania po weryfikacji.",
    "canotModifyTips" : "Zmiany NIE są dozwolone po wysłaniu, czy na pewno wysłać?",
    "rebindEmailTips" : "Twój e-mail to :\$email, proszę naciśnij tutaj aby otrzymać kod weryfikacyjny",
    "reGetVrfCode" : "Pobierz kod",
    "findPwdWayTips" : "Proszę wybrać jeden z poniższych sposobów",
    "emailWay" : "Odzyskaj przez e-mail bezpieczeństwa",
    "emailWayTips" : "Otrzymasz wiadomość e-mail z potwierdzeniem, po czym będziesz mógł zresetować hasło.",
    "quessionWay" : "Wyszukiwanie na podstawie pytań bezpieczeństwa",
    "quessionWayTips" : "Odpowiedz na utworzone pytania bezpieczeństwa, a następnie zresetuj hasło",
    "resetPwdBtn" : "Zresetuj hasło",
    "lastStep" : "Poprzedni",
    "sendEmailTips" : "Wysłaliśmy Ci wiadomość e-mail na adres \$email.<br>Proszę wprowadź tutaj otrzymany kod weryfikacyjny.",
    "setNewPwdTips" : "Gratulacje!<br>Tożsamość użytkownika zweryfikowana. Teraz możesz zresetować swoje hasło.",
    "termsOfUse" : "Warunki użytkowania",
    "copy_success" : "Skopiowano",
    "creatework_create" : "Bilet",
    "creatework_createHolder" : "Wybierz rodzaj",
    "creatework_title" : "Temat",
    "creatework_titleHolder" : "Proszę wpisać temat",
    "creatework_detail" : "szczegóły",
    "creatework_detailHolder" : "Opis nie może zawierać więcej niż 200 znaków",
    "creatework_uploadTips" : "Proszę przesyłać tylko pliki w formacie jpg/png. Wgrywany plik musi być mniejszy niż 5 MB.",
    "creatework_selectBox_selectTile" : "Rodzaj",
    "creatework_goGame" : "Powrót",
    "creatework_history" : "Historia",
    "mylist_noYet" : "Brak zapisu",
    "mywork_solved" : "Problem rozwiązany?",
    "mywork_service" : "Oceń nas",
    "mywork_messageHolder" : "Nowa wiadomość",
    "mywork_score" : "Wynik",
    "mywork_confirm" : "POTWIERDŹ",
    "creatework_selectBox_selectList3" : "Inne",
    "creatework_selectBox_selectList2" : "Konto",
    "close" : "Zamknij",
    "creatework_gameHolder" : "Wybierz Grę",
    "creatework_serverHolder" : "Wybierz serwer",
    "contactService" : "Kontakt CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Gra:",
    "creatework_server" : "Serwer:",
    "creatework_role" : "Postać:",
    "selectRoleName" : "wybierz postać",
    "creatework_noRole" : "Brak postaci",
    "creatework_noGame" : "Lista gier jest pusta",
    "creatework_noServer" : "Lista serwerów jest pusta",
    "termText" : "Zgadzm się na {mainHost}",
    "backLogin" : "ODMÓW",
    "creatework_roleHolder" : "Dostęp po wybraniu postaci",
    "findPwdFailTips" : "Nie ustawiłeś pytań bezpieczeństwa. Prosimy o kontakt z działem obsługi klienta.",
    "payMall" : "Market",
    "selectPayment" : "ilość",
    "plzSelectPayWay" : "wybierz kanał",
    "gainPlus" : "Dodaj",
    "gainMorePlus" : "Dodaj Więcej",
    "gainMostPlus" : "Maks",
    "plzSelectPayType" : "Wybierz metodę płatności",
    "roleName" : "Postać",
    "payWay" : "Kanał płatności",
    "plzSelectOtherWay" : "Alternatywny kanał płatności",
    "payment" : "Ilość",
    "compensateTips" : "Nadwyżka zostanie zwrócona do Ciebie w \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "Waluta w grze",
    "compensate" : "Odszkodowanie",
    "payWayPlus" : "Bonus kanałowy",
    "neddPay" : "Płatność",
    "submitOrder" : "Prześlij",
    "screenshotTips" : "Uwaga: zrób zrzut ekranu swojego zamówienia na wypadek błędu transakcji.",
    "storeFail" : "Nie udało się doładować",
    "storeFailTips" : "Transakcja nie powiodła się. Proszę złożyć zamówienie ponownie lub skontaktować się z naszym działem obsługi klienta.",
    "storeAcceptance" : "Przetwarzanie",
    "storeSuccessTips" : "Transakcja zostanie zrealizowana w ciągu 15 minut.",
    "orderNumber" : "Nr zamówienia",
    "buyProduct" : "Przedmiot doładowania",
    "transactionAmount" : "Ilość",
    "failReason" : "Powód",
    "payOntherORder" : "Nowe zamówienie",
    "reStore" : "Naładuj się ponownie",
    "confirm" : "Potwierdź",
    "switch" : "Przełącz konto",
    "completeTips" : "Proszę wypełnić swoje dane osobowe. <mark class=\"yellowMarkColor\">Informacji nie będzie można edytować ponownie</mark>. Gdy będziesz próbował odzyskać utracone konto, zostaniesz poproszony o podanie poprawnych danych osobowych.",
    "creatework_selectBox_selectList0" : "Błąd Gry",
    "creatework_selectBox_selectList1" : "Błąd Płatności",
    "creatework_selectBox_selectList4" : "Błąd Tłumaczenia",
    "mywork_solvedText" : "Problem rozwiązany",
    "browserPayErrBtnText" : "Błąd Płatności",
    "browserPaySucBtnText" : "Płatność ukończona",
    "browserPayingTips" : "Przekierowanie do platformy innej firmy.<br/>Można zamknąć tę stronę po dokonaniu płatności.",
    "price_list_empty" : "Nie dotyczy",
    "pointCardTips" : "Uwaga: Ten element obsługuje tylko kartę \$paymentAmount",
    "forgetPwd" : "Zapomniałeś hasła?",
    "payCenter" : "Centrum Doładowania",
    "willGet" : "Otrzymasz",
    "goods" : "przedmiot",
    "discount" : "Bonus",
    "payDiscount" : "Odszkodowanie",
    "payDiscountTips" : "Dodatkowe punkty zostaną zamienione na Diamenty",
    "hasQuestionPlease" : "W razie jakichkolwiek pytań prosimy o",
    "pwdValidateMsg" : "Hasło musi zawierać od 6 do 20 znaków",
    "payWayPlusC" : "Bonus kanałowy",
    "fwtk" : "WARUNKI ŚWIADCZENIA USŁUG",
    "yszc" : "POLITYKA PRYWATNOŚCI",
    "exchange" : "Wymiana kodów podarunkowych",
    "remember" : "pamiętaj mój wybór",
    "thirdInfo" : "O koncie",
    "thirdInfoContent" : "Proszę powiązać swoje konto w Centrum Użytkownika w grze. Następnie zaloguj się do gry używając powiązanego konta.",
    "unLink" : "Ta metoda nie jest obecnie obsługiwana",
    "favour" : "Zakładki",
    "goStoreTip" : "Przejdź do strony płatności",
    "go" : "Idź",
    "otherLogin" : "Inne metody logowania",
    "qrCodeTip" : "Zeskanuj kod QR, aby zacząć!",
    "favourTip" : "Dodaj stronę do zakładek, aby później znów grać!",
    "share" : "Udostępnij",
    "landscapeTip" : "Proszę kontynuować w trybie portretowym",
    "leaveTip" : "Wyjść z gry?",
    "selectRole" : "Wybierz postać",
    "selectMoney" : "Wybierz rekwizyt",
    "seletGameInfoFirst" : "Proszę wybrać grę",
    "lowerIE" : "Za stara wersja IE",
    "linkTermText" : "Zaakceptowałem {mainHost} [Warunki użytkowania] i [Polityka prywatności]",
    "download" : "Pobierz",
    "favourAndDownloadTip" : "Dodaj tę stronę do wyszukiwarki lub pobierz na PC",
    "payReward" : "Nagroda Doładowania",
    "hasEqualReward" : "Podwójny bonus dla obu metod płatności",
    "payBtnText" : "Płatność",
    "storeHoaveReward" : "Bonus doładowania",
    "showMorePayWay" : "Więcej Metod",
    "needPaymentCount" : "Ilość",
    "orderDetail" : "Szczegóły",
    "selectPayWayPlz" : "Wybierz płatność",
    "countryCode" : "Kod kraju",
    "deleteaccount_title1" : "Usuń konto",
    "deleteaccount_title2" : "Żądanie usunięcia konta",
    "deleteaccount_step1_1" : "Twoje konto zostanie zamrożone na 14 dni od momentu usunięcia konta. Po upływie 14 dni, Twoje konto zostanie trwale usunięte. Nie będziesz mógł zalogować się na inne konta społecznościowe.",
    "deleteaccount_step1_2" : "Możesz odwołać usunięcie danych w ciągu 14 dni poprzez poniższy link:",
    "deleteaccount_step1_3" : "Po usunięciu konta, nie będzie można przywrócić informacji o koncie. Użytkownik nie otrzyma rekompensaty za jakiekolwiek straty spowodowane usunięciem konta.",
    "deleteaccount_step1_4" : "Czy na pewno chcesz usunąć swoje konto?",
    "deleteaccount_step2_1" : "Proszę potwierdzić, że chcesz usunąć swoje konto i postać.",
    "deleteaccount_step2_2" : "Proszę wpisać \\&quot;Usuń\\&quot; aby zakończyć usuwanie.",
    "deleteaccount_step3" : "Twoje konto zostanie usunięte w ciągu 14 dni.",
    "accountrecovery_note" : "Uwaga:",
    "accountrecovery_tips" : "Użytkownik może odwołać usunięcie konta tylko podczas 14-dniowego okresu zamrożenia.",
    "accountrecovery_Submitted2" : "Odwołanie zostało złożone. Twoje konto zostanie przywrócone później.",
    "accountrecovery_Failed" : "Nie udało się",
    "accountrecovery_Failed_1" : "Stan konta jest normalny. Możesz się zalogować.",
    "accountrecovery_Failed_2" : "Nie znaleziono informacji o znaku.",
    "accountrecovery_success" : "Konto przywrócone",
    "account_normal" : "Stan konta jest normalny. Nie ma potrzeby przywracania.",
    "account_unablerestore" : "Konto zostało usunięte. Nie można przywrócić.",
    "accountrecovery_roleHolder" : "Wprowadź nazwę swojej postaci",
    "accountrecovery_headerTitle" : "Cofnij usunięcie konta",
    "guideTitle" : "Twój zakup nie doszedł do skutku. Prosimy o kontakt z naszym działem obsługi klienta.",
    "accountFix" : "Odzyskiwanie konta",
    "inputAccount" : "Proszę wpisać nazwę konta, które chcesz odzyskać",
    "applyForAccountFix" : "Odzyskiwanie konta",
    "nonEnterItem" : "Informacje do dodania: Data rejestracji; Numer modelu; Nazwa urządzenia; Numer paszportu lub dowodu osobistego, E-mail kontaktowy; Proszę wypełnić puste pola.",
    "resetOT" : "Czas minął, proszę wysłać Weryfikację ponownie",
    "addOT" : "Czas minął, proszę ponownie przesłać informacje dodatkowe",
    "errorPwd" : "Hasło musi zawierać od 6-20 do 20 znaków, w tym litery, cyfry, \".\", \"_\" i \"@\".",
    "verifyAccount" : "Brakuje informacji o koncie, proszę sprawdzić ponownie.",
    "selectRegisterTime" : "Prosimy o wybranie godziny rejestracji.",
    "enterBindEmail" : "Proszę wpisać swój zweryfikowany email.",
    "enterUsedPhoneType" : "Proszę wpisać model swojego telefonu komórkowego.",
    "enterIdfaGpid" : "Proszę wpisać UDID swojego urządzenia.",
    "enterContactEmail" : "Nieprawidłowy format adresu e-mail kontaktu; proszę wpisać ponownie",
    "confirmTermsPrivacy" : "Prosimy o zapoznanie się i zaakceptowanie warunków korzystania z serwisu oraz polityki prywatności.",
    "enterRechargeRemark" : "Proszę włożyć kartę doładowania.",
    "uploadImg" : "Proszę przesłać skan dowodu osobistego, maksymalny rozmiar to 20MB",
    "selectIDType" : "Proszę wybrać rodzaj dokumentu tożsamości.",
    "enterIDNum" : "Proszę wpisać swój numer paszportu lub numer dowodu osobistego.",
    "enterIP" : "Proszę wpisać adres IP, którego użyłeś do rejestracji.",
    "enterQueryNum" : "Proszę wprowadzić ID weryfikacji",
    "enterQueryPwd" : "Proszę wpisać Hasło weryfikacji",
    "errorQueryItem" : "Niepoprawne ID lub Hasło weryfikacji, proszę spróbować ponownie",
    "enterPassword" : "Proszę wprowadzić nowe hasło.",
    "enterPasswordAgain" : "Proszę potwierdzić swoje nowe hasło.",
    "enterPasswordNonSame" : "Niezgodne hasło",
    "enterEmail" : "Proszę wpisać adres e-mail",
    "sendSuccess" : "E-mail został wysłany",
    "enterCode" : "Proszę wpisać kod weryfikacyjny.",
    "errorCode" : "Nieprawidłowy kod weryfikacyjny",
    "selectQuest" : "Proszę wybrać pytanie bezpieczeństwa",
    "enterAnswer" : "Proszę wpisać odpowiedź",
    "selectDifferQuest" : "Proszę wybrać 3 pytania bezpieczeństwa i odpowiedzi",
    "addSuccess" : "Twoje dane zostały przesłane.",
    "picFormt" : "Format zdjęcia musi być jpg, png lub gif.",
    "countdownBefore" : "Resetuj odliczanie",
    "countdownAfter" : "(Link wygaśnie o godzinie 00:00:00, prosimy o ponowne złożenie wniosku)",
    "uploadDone" : "Przesyłanie zakończone",
    "uploadFail" : "Przesyłanie nie powiodło się",
    "applySuccess" : "Wniosek zatwierdzony",
    "applyFailed" : "Wniosek odrzucony",
    "resetQuestAlterFailed" : "Nie udało się zmienić pytania bezpieczeństwa.",
    "resetQuestError" : "Błąd wprowadzania danych.",
    "resetQuestNone" : "Nie znaleziono zlecenia zapytania.",
    "resetQuestAltered" : "Pytania bezpieczeństwa zostały zmienione.",
    "illegalOperation" : "Nielegalne działanie",
    "queryNotExist" : "Numer zapytania nie istnieje.",
    "queryPasswordError" : "Błąd znalezienia hasła",
    "auditing" : "W oczekiwaniu na zatwierdzenie",
    "notPass" : "Odrzucono",
    "suppleInformation" : "Prześlij informacje uzupełniające",
    "suppleInformationUnHandle" : "Przesłano informacje uzupełniające, proces w toku.",
    "suppleInformationTimeout" : "Czas oczekiwania na przesłanie informacji uzupełniających został przekroczony.",
    "repairedAccountSuccess" : "Naprawa konta została zakończona.",
    "repairedAccountLost" : "Operacja naprawy konta nie powiodła się.",
    "loginStateNone" : "Nie zalogowano się lub sesja wygasła.",
    "repairedAccountTimeout" : "Upłynął czas naprawy konta.",
    "changePasswordSucc" : "Hasło zostało zmienione.",
    "emailSendFailed" : "Nie udało się wysłać maila.",
    "emailSendLimit" : "Skrzynka pocztowa może już dzisiaj nie otrzymać żadnych kodów weryfikacyjnych.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "Kod weryfikacyjny e-mail został wysłany.",
    "alterSuccess" : "Zmiana zapisana",
    "questionAlterSuccess" : "Pytanie bezpieczeństwa zostało zmienione.",
    "username" : "Nazwa konta",
    "code" : "Proszę wpisać tutaj kod weryfikacyjny",
    "selectServiceType" : "Proszę wybrać Rodzaj Usługi",
    "submitForm" : "Prześlij Formularz",
    "apply" : "Aplikuj",
    "reviewApplicationStatus" : "Przegląd statusu aplikacji",
    "instantReviewOfTheStatus" : "Natychmiastowy przegląd statusu",
    "reviewStatus" : "Status weryfikacji",
    "backToLogin" : "Powrót do logowania",
    "previous" : "Poprzedni",
    "applyDesc" : "Proszę wprowadzić informacje, abyśmy mogli pomóc. Musisz wypełnić puste pola znakiem * . Jeśli takiej informacji brakowało na Twoim koncie, wpisz \"Brak\".",
    "additionalServices" : "Usługi dodatkowe",
    "resetSecurityEmail" : "Resetowanie bezpieczeństwa E-mail",
    "resetSecurityQuest" : "Resetuj pytania bezpieczeństwa",
    "registrationDate" : "Data rejestracji",
    "month" : "Miesiąc",
    "year" : "Rok",
    "emailBound" : "Powiązanie E-mail",
    "modelNumber" : "Rodzaj modelu mobilnego;",
    "deviceName" : "Nazwa Urządzenia",
    "provideRecharge" : "Prosimy o dostarczenie szczegółowego i kompletnego zapisu doładowania, zawierającego czas, metodę, kwotę, numer zamówienia i identyfikator transakcji, abyśmy mogli to potwierdzić.",
    "selectCountry" : "Region",
    "passportID" : "Paszport/dowód tożsamości",
    "upload" : "Prześlij",
    "del" : "usuń",
    "pleaseUpload" : "Proszę przesłać skan dowodu osobistego, o maksymalnym rozmiarze 20MB",
    "uploadAgain" : "Prześlij ponownie",
    "enterDesc" : "Proszę wpisać wszelkie informacje, które potwierdzają własność konta",
    "contactEmail" : "E-mail Kontaktowy",
    "applyNoteAttr" : "Uwaga",
    "applyNoteDate" : "prosimy o podanie adresu e-mail, aby można było otrzymać wyniki zgłoszenia",
    "agree" : "Zgadzam się na",
    "UJOYTerms" : "Warunki użytkowania",
    "privacy" : "Polityka prywatności",
    "reviewStatusOfAccountFix" : "Przeglądanie statusu naprawy konta",
    "enterReviewID" : "Proszę wprowadzić ID weryfikacji",
    "enterReviewPwd" : "Proszę wpisać Hasło weryfikacji",
    "review" : "Weryfikacja",
    "reviewNoteAttr" : "Uwaga",
    "reviewNoteData" : "Sprawdź swój e-mail kontaktowy na wypadek, gdybyś zapomniał ID weryfikacji i hasła weryfikacji.",
    "haveResetInfo" : "Zresetowałeś swoje dane",
    "resetProfile" : "Zresetuj swój profil",
    "desc" : "Gratulacje! Aplikacja zatwierdzona! Proszę zresetować swój profil.",
    "changePwd" : "Zmień Hasło",
    "resetPwd" : "Resetuj Hasło",
    "reset" : "Resetuj",
    "enterNewPwd" : "Proszę wprowadzić nowe hasło",
    "confirmNewPwd" : "Proszę potwierdzić nowe hasło",
    "successResetPwd" : "Pomyślnie zresetowano hasło",
    "bindSecurityEmail" : "Powiąż Zabezpieczenie E-mail",
    "resetPwdDesc" : "Resetowanie hasła, gdy zapomniałeś hasła lub konto zostało skradzione",
    "bindCommon" : "Powiąż",
    "sendCommon" : "Wyślij",
    "enterVcode" : "Proszę wpisać kod weryfikacyjny.",
    "successResetEmail" : "Pomyślne zresetowanie zabezpieczenie e-mail",
    "resetQuest" : "Resetuj pytania bezpieczeństwa",
    "resetQuestDesc" : "Zresetuj hasło, jeśli zapomniałeś hasła lub uważasz, że informacje o Twoim koncie zostały skradzione",
    "successResetQuest" : "Pomyślne zresetowanie pytań bezpieczeństwa",
    "hide" : "Ukryj",
    "addRegisterTime" : "Czas rejestracji;",
    "modelNum" : "Numer modelu: IDFA/GPID",
    "registrationIP" : "IP rejestracji;",
    "addRechargeRecord" : "Zapis doładowania;",
    "serviceReply" : "Odpowiedź z Biura Obsługi Klienta:",
    "addDataLimitTime" : "Data dodania informacji uzupełniających:",
    "addMoreInfo" : "Dodaj więcej informacji",
    "applicationSubmit" : "Wniosek złożony",
    "underReviewStatus" : "Twój profil jest w trakcie przeglądu, otrzymasz odpowiedź w ciągu następnego dnia roboczego. Status przeglądu:",
    "reviewID" : "ID weryfikacji",
    "reviePwd" : "Hasło weryfikacji",
    "enterReviewIDNPwd" : "Wprowadź ID weryfikacji i hasło weryfikacji, aby sprawdzić status",
    "homepage" : "Strona startowa",
    "checkEmailAttr" : "Uwaga",
    "checkEmailData" : "Sprawdź swój e-mail kontaktowy na wypadek, gdybyś zapomniał swojego identyfikatora weryfikacji i hasła weryfikacyjnego.",
    "underReview" : "W trakcie weryfikacji",
    "underReviewReply" : "Twój profil jest w trakcie sprawdzania. Odpowiemy tak szybko, jak to będzie możliwe. Dziękujemy za cierpliwość!",
    "failed" : "Aplikacja nie powiodła się",
    "reason" : "Powód: ### Dlatego aplikacja nie powiodła się, proszę podać poprawne informacje, nasz personel pomoże. Dziękujemy za współpracę!",
    "underReviewAdd" : "Twój profil jest w trakcie weryfikacji. Brakuje części informacji lub są one niespójne, proszę dodać więcej informacji, abyśmy mogli to potwierdzić!",
    "addInfoRequired" : "Wymagane informacje dodatkowe",
    "dateForAddInfo" : "Data dodania informacji uzupełniających:",
    "addInfo" : "Dodatkowe informacje",
    "addInfoSubmit" : "Dodatkowe informacje zostały przesłane! Dziękujemy za cierpliwość!",
    "hasBeenRepaired" : "Konto zostało naprawione",
    "opExpired" : "Operacja naprawy konta wygasła",
    "approved" : "Zatwierdzono",
    "haveSubmitted" : "Przesłałeś",
    "sessionExpired" : "Nie zalogowałeś się jeszcze lub wartość sesji wygasła",
    "submitted" : "Przesłano",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Niespójny numer ID;",
    "addItemIDPhoto" : "Zdjęcie ID;",
    "idfaTitle" : "Jak znaleźć urządzenie IDFA lub GPID?",
    "idfaSubTitle1" : "Dla użytkowników systemu ios - znalezienie IDFA",
    "idfaSubTitle1Desc1" : "1.Pobierz aplikację 【<em>MyIDFA</em>】 z App Store",
    "idfaSubTitle1Desc2" : "2.Otwórz <em>aplikację</em> i znajdziesz identyfikator <em>IDFA</em>.",
    "idfaSubTitle2" : "Dla użytkowników Androida - znalezienie swojego GPID",
    "idfaSubTitle2Desc1" : "1.wejdź w sekcję <em>\"ustawienia\"</em>",
    "idfaSubTitle2Desc2" : "2.wejdź w <em>\"Google\"</em> pod stroną <em>KONTA</em>",
    "idfaSubTitle2Desc3" : "3.następnie wejdź w <em>\"Reklamy\"</em> i znajdziesz swoje <em>GPID</em>.",
    "uploadIDCard" : "Proszę przesłać skan dowodu osobistego, o maksymalnym rozmiarze 20MB",
    "uploadTipsBefore" : "Rozmiar pliku nie może być większy niż",
    "uploadTipsAfter" : "M",
    "submitError" : "Błąd spowodowany brakiem numeru ID lub błędnymi danymi konta.",
    "applyLimitError" : "Przekroczenie dziennego limitu stosowania. (3 razy każdego dnia)",
    "applyDisabled" : "Możesz zgłosić się tylko raz na 10 minut.",
    "inputDataError" : "Dane nie są uzupełnione.",
    "dataException" : "Wyjątek dotyczący danych",
    "picSizeLimit" : "Rozmiar pliku zdjęcia nie może przekraczać 5MB",
    "picTypeLimit" : "Wgrywaj tylko pliki JPG, PNG, GIF",
    "picNull" : "Obraz jest pusty",
    "alteredPassword" : "Hasło zostało zmienione.",
    "inputError" : "Błąd wprowadzania danych.",
    "pwdChangefailed" : "Nie udało się zmienić hasła.",
    "sendEmailCodeDisabled" : "Kod weryfikacyjny może być wysłany ponownie dopiero po pewnym czasie.",
    "alteredEmail" : "E-mail został zmieniony.",
    "inputEmailError" : "Błąd wprowadzania e-mail",
    "operationFailed" : "Operacja nie powiodła się",
    "codeNull" : "Nie wprowadziłeś jeszcze kodu weryfikacyjnego.",
    "findPwd" : "Nie pamiętam hasła",
    "findAccountAndPwd" : "Zapomniałem konta/hasła",
    "usualDeviceNum" : "Numer Modelu: IDFA/GPID",
    "usualPhoneNum" : "Nazwa Urządzenia",
    "registerTimeError" : "Niezgodna data rejestracji;",
    "bindEMailError" : "Niespójny powiązany e-mail;",
    "rechargeRecordError" : "Niespójny zapis doładowania;",
    "registerIPError" : "Niespójna data rejestracji;",
    "deviceNumError" : "Niespójne IDFA/GPID;",
    "deviceModelError" : "Niespójny model urządzenia;",
    "confirmTerms" : "Prosimy o wyrażenie zgody na warunki korzystania z usługi",
    "applyFixAccount" : "Jeśli powyższe sposoby nie przyniosą rezultatu, możesz ubiegać się o <span>odzyskanie konta</span>.",
    "findPwdByFixAccount" : "Zaleca się ustawienie e-maila bezpieczeństwa w celu odzyskania konta.",
    "connectFail" : "Rozłączono z usługami Google, proszę spróbować ponownie",
    "h5_favour_has_gift" : "Zakładka do przeglądarki! (To konto już odebrało nagrodę)",
    "h5_favour_get_gift" : "Gratulacje! Otrzymałeś nagrodę. Proszę sprawdzić w grze.",
    "h5_get_gift_fault" : "Nie można złożyć wniosku. Proszę spróbować ponownie później i skontaktować się z naszym Zespołem Obsługi, jeśli problem nadal występuje.",
    "h5_favour_please_select" : "Proszę wybrać serwer/postać",
    "h5_favour_login_get" : "Zaloguj się i dodaj zakładkę do przeglądarki, aby odebrać nagrodę!",
    "h5_favour_tip" : "Dodaj zakładkę do przeglądarki, aby odebrać nagrodę!",
    "h5_favour_select_serve" : "Proszę wybrać serwer",
    "h5_favour_select_role" : "Proszę wybrać postać",
    "store_product_paytype_error" : "Za pomocą tej metody płatności nie można dokonać zakupu wybranego towaru.",
    "SwitchWithThirdWay" : "Przełącz się na \${type}",
    "moreGame" : "więcej gier",
    "serviceTitle" : "Usługi",
    "h5_download_login" : "Proszę się zalogować.",
    "h5_download_tips" : "Proszę uruchomić grę z poziomu klienta.",
    "h5_download_repeat_get" : "Zgłosiłeś ten pakiet upominkowy.",
    "h5_download_succ" : "Proszę najpierw pobrać klienta.",
    "h5_download_repeat_role" : "Postać jest powiązana",
    "currentLoginAccount" : "Obecne konto:",
    "fb_canvas_fullscreen" : "Rozwiń",
    "fb_canvas_website" : "Strona startowa",
    "fb_canvas_like_share" : "Udostępnij",
    "fb_canvas_service" : "Wsparcie",
    "fb_canvas_login_fail" : "Nieudany login",
    "fb_canvas_pay_return" : "Anulowałeś transakcję",
    "fb_canvas_root_tip" : "Proszę najpierw zaloguj się na Facebooku, aby dokonać autoryzacji",
    "h5_popup_title" : "Płatność",
    "h5_popup_submit" : "Zapłać",
    "h5_popup_last_used" : "Ostatnio używane",
    "h5_popup_quit_tips" : "Czy na pewno chcesz anulować płatność",
    "h5_popup_quit_check" : "TAK",
    "h5_popup_quit_cancel" : "NIE",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Informacje o produkcie nie zostały jeszcze uzyskane. Proszę odświeżyć stronę",
    "h5_popup_server_empty" : "Nie ma jeszcze listy serwerów. Proszę odświeżyć stronę",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "w ciągu 14 dni. Odwołać teraz?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Czy na pewno chcesz usunąć konto wraz z jego danymi?",
    "account_delete_fwq" : "Serwer",
    "account_delete_zhm" : "Postać",
    "account_delete_jshflj" : "Link do odzyskiwania postaci",
    "account_delete_qzyzmdxx" : "(Wielkość liter ma znaczenie)",
    "account_delete_jtbcysxx" : "Zaleca się zrobienie zrzutu ekranu z powyższymi informacjami w celu odzyskania konta.",
    "deleteaccount_step3_2" : "Po upływie 14 dni, Twoje konto zostanie usunięte. Nie będziesz mógł przywrócić swojego konta. Stracisz wszystkie informacje o swoim koncie.\\n\\nMożesz odwołać usunięcie konta poprzez",
    "h5_guest_login" : "Gość",
    "h5_click_copy" : "",
    "questionnaire_btn" : "kwestionariusz dochodzeniowy",
    "h5_header_store_text" : "Doładuj",
    "h5_header_home_text" : "Strona startowa",
    "h5_check_gift_list_text" : "Informacje o nagrodzie",
    "yourServer" : "Twój serwer",
    "allServer" : "Wszystkie serwery",
    "h5_header_screen" : "Pełny Ekran",
    "h5_verticalTip" : "Zalecany jest tryb krajobrazowy.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Ostatni",
    "moreGames" : "Więcej",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "domyślny",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Bonus Metody Płatności\nWaluta bonusu = Kwota wypłacona * kurs waluty * kurs bonusu x Bonus Metody Płatności\nWaluta bonusu = kwota wpłacona * kurs waluty * kurs bonusu\n*Uwaga: waluta bonusu nie będzie uwzględniana w wydarzeniach doładowania ani w DOŚW VIP.* W przypadku gier, które są uruchamiane na całym świecie, kwota płatności jest obliczana w dolarach amerykańskich. W razie jakichkolwiek pytań prosimy o kontakt z działem obsługi klienta.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Jeśli na poprzedniej stronie wybrałeś opcję zapisania numeru karty, dane Twojej karty (**** **** **** 1234) będą gromadzone w wersji zaszyfrowanej.",
    "quickcard_result_tip_two" : "Dla Twojej wygody przechowujemy zaszyfrowane dane, a Ty nie musisz wprowadzać numerów kart przy kolejnych zakupach.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Oświadczenie o przechowywanych danych uwierzytelniających",
    "quickcard_info_tip_one" : "Aby lepiej chronić bezpieczeństwo danych klientów, Visa i Mastercard wprowadzają nowe definicje \"przechowywanych danych uwierzytelniających\" oraz nowe zasady dotyczące przechowywanych danych uwierzytelniających i transakcji inicjowanych przez sprzedawcę.",
    "quickcard_info_tip_two" : "Kiedy dokonujesz zakupu na naszej stronie internetowej, gromadzimy dane Twojej karty (1234 **** **** 1234） w wersji zaszyfrowanej. Zaszyfrowane dane będziemy przechowywać przez 4 lata i w przypadku jakichkolwiek zmian będziemy aktualizować umowę i politykę prywatności na naszej stronie internetowej. Zaszyfrowane dane przechowujemy wyłącznie dla Twojej wygody i nie musisz wprowadzać numerów kart przy kolejnych zakupach.",
    "search_product" : "znajdź przedmiot",
    "search_price" : "znajdź cenę",
    "price" : "cena",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Please Choose Character",
    "storeSocialLogin" : "Log in with SNS accounts",
    "storeAccountIdLogin" : "Log in with account ID",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Search",
    "storeSelectProductTitle" : "Choose Items",
    "storeInputNameSearch" : "Enter item name and search",
    "storeInputPriceSearch" : "Enter item price and search",
    "storeNoFindProduct" : "Item not found. Please try again.",
    "storePriceUp" : "Price↑",
    "storePriceDown" : "Price↓",
    "storeLookDetail" : "Details",
    "storeChangeProduct" : "Change Item",
    "storeWelcome" : "Welcome",
    "storeLookMore" : "More",
    "storeHasSelect" : "Item Selected",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Details",
    "storeUidGuideStep1" : "Tap Settings > More > Account",
    "storeUidGuideStep2" : "Enter the account ID when topping up",
    "storeSelectAndLook" : "Please select your character first",
    "storeSwitchWay" : "Switch Login Method",
    "type1" : "Daily Sale",
    "type2" : "Hero",
    "type3" : "Battle Gear",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Resource",
    "type8" : "Build Speedup",
    "type9" : "Rare Items",
    "type10" : "Alliance",
    "type11" : "Diamond",
    "type12" : "Module",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nanoweapon",
    "type16" : "Grand Prize",
    "type17" : "",
    "type9999" : "Limited Offer",
    "type10000" : "Gift Center",
    "type10001" : "Holiday Events",
    "typeother" : "Inne produkty",
    "switchChar" : "Switch Character",
    "howToFindUid" : "How to find my account ID?",
    "choosePayWay" : "Choose a Payment Method",
    "new_apple_deleteaccount_stepsub_title" : "Anuluj auto-odnawianie",
    "new_apple_deleteaccount_stepsub_1" : "Na Twoim koncie znaleziono subskrypcję z automatycznym odnawianiem. Zaleca się anulowanie automatycznego odnawiania subskrypcji przed usunięciem konta, aby uniknąć niezamierzonych zakupów.",
    "new_apple_deleteaccount_stepsub_2" : "Anuluj auto-odnawianie",
    "new_apple_deleteaccount_stepsub_later" : "Później",
    "new_apple_deleteaccount_stepsub_now" : "Teraz",
    "new_apple_deleteaccount_title" : "Żądanie usunięcia konta",
    "new_apple_deleteaccount_step1_1" : "Prosimy o uważne zapoznanie się z poniższymi zasadami i warunkami:",
    "new_apple_deleteaccount_step1_2" : "Twoje konto zostanie <span class=\"highlight\">trwale usunięte</span> bez powrotu. NIE będziesz mógł używać go do logowania się do gry. Wszystkie usunięte informacje z Twojego konta NIE będą mogły być przywrócone.",
    "new_apple_deleteaccount_step1_3" : "Jeśli chcesz odłączyć konto w mediach społecznościowych od konta, skontaktuj się z działem obsługi klienta w celu wykonania operacji odłączenia przed usunięciem konta. W przeciwnym razie, po pomyślnym usunięciu konta, nie będzie można korzystać z połączonego z nim konta w mediach społecznościowych, aby zalogować się do gry.Przed złożeniem wniosku o usunięcie konta upewnij się, że prawidłowo dysponujesz wirtualnymi aktywami w grze.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Jeśli chcesz ubiegać się o zwrot pieniędzy, zrób to również przed usunięciem konta.</span> Przed usunięciem konta upewnij się, że prawidłowo pozbyłeś się swoich wirtualnych aktywów.",
    "new_apple_deleteaccount_step2_1" : "Czy prawidłowo pozbyłeś się swoich wirtualnych zasobów w grze? Jeśli nie, skontaktuj się w tej sprawie z działem obsługi klienta, zanim złożysz wniosek o usunięcie konta.",
    "new_apple_deleteaccount_step2_2" : "Aby zakończyć usuwanie konta, naciśnij przycisk \"Delete\". Raz usuniętego konta nie można cofnąć.",
    "new_apple_deleteaccount_step2_3" : "Aby zakończyć usuwanie konta, naciśnij przycisk \"Delete\"",
    "new_apple_deleteaccount_step3_1" : "Wniosek o usunięcie konta został złożony. Następujące konto zostało już usunięte:",
    "new_apple_deleteaccount_step3_2" : "Proszę utworzyć nowe konto, jeśli chcesz się ponownie zalogować do gry.",
    "new_apple_deleteaccount_step4_1" : "Usunąłeś swoje stare konto. Następnym razem zaloguj się przy użyciu nowego konta.",
    "currencyTypeName" : "Waluta",
    "has_select_product" : "Your Items:",
    "n_product" : "\${n}",
    "look_detail_product" : "View All",
    "limit_buy_product" : "Purchase limit for this item: \${n}",
    "limit_order" : "You can only buy a maximum of \${n} items each time.",
    "limit_order_remove_tip" : "You have reached the purchase limit for some items in this cart. Do you want to remove them?",
    "paytype_limit" : "This payment method cannot be used to buy some of your items. Please choose a different payment method or try buying them separately.",
    "check_remove_cart" : "Remove from cart?",
    "remove_cart" : "Remove",
    "confirm_product" : "Confirm",
    "select_paytype" : "Select Payment Method",
    "cart_is_empty_tip" : "No items found. Please select an item first.",
    "thirty_tip" : "If the items you have purchased fail to arrive within 30 minutes, please contact our customer support.",
    "total_n_product" : "Item x\${n}",
    "look_detail_of_cart" : "View All",
    "order_detail" : "Item List",
    "total_detail" : "Quantity:",
    "add_to_cart" : "Add to Cart",
    "back_to_select" : "Back",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Potwierdź",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visit \nWebsite",
    "visitorLogin" : "Guest",
    "tokenLogin" : "OTP",
    "fbLogin" : "log in with Facebook",
    "googleLogin" : "Log in with Google",
    "twitterLogin" : "Log in with Twitter",
    "vkLogin" : "Log in with VK",
    "agreementTextStart" : "By logging into the game, you confirm that you have read and agree to the Terms of Service and Privacy Policy.",
    "userCenter" : "User Center",
    "welcomeBack" : "Welcome Back",
    "continueGame" : "START",
    "officialPay" : "Top-Up Center",
    "changeAccount" : "Switch Account",
    "back" : "Back",
    "tokenKey" : "OTP",
    "inputUid" : "Enter your UID",
    "inputToken" : "Enter your OTP",
    "inputCkCode" : "Type the text",
    "enterGame" : "START",
    "tokenTip" : "Protect Your Account With OTP Verification",
    "howToGetToken" : "How to get my one-time password?",
    "getStep1" : "Step 1: Go to Settings > Account > User Center",
    "getStep2" : "Step 2: Tap OTP",
    "getStep3" : "Step 3: Copy and enter your UID and one-time password",
    "copy" : "Copy",
    "lastRefresh" : "Refreshes in:",
    "second" : "s",
    "immediatelyRefresh" : "Refresh Now",
    "frequently" : "Operation too frequent. Please try again later.",
    "loginFail" : "Login failed. Incorrect password.",
    "tokenIntro" : "About One-Time Password (OTP)",
    "tokenIntro1" : "1. One-time passwords expire in 120 seconds. Use them wisely to keep your account safe and secure.",
    "tokenIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "nextStep1" : "Potwierdź",
    "couponCanUse" : "Do użycia",
    "couponCanNotUse" : "Nie do użycia",
    "couponHasNoCoupon" : "Brak kuponów",
    "couponUseTip" : "Użyj 1 kupna do każdego zamówienia",
    "couponValidTime" : "Ważność",
    "couponFuilCanUse" : "Do użycia przy zamówieniach powyżej \${price} \${currency}",
    "couponNoLimit" : "Brak limitów",
    "couponAllProductCanUse" : "Wszystkie przedmioty",
    "couponPartProductCanUse" : "Specjalne przedmioty",
    "couponPartPaytypeCanUse" : "Specjalne kanały płatności",
    "couponOnlyCoinCanUse" : "Tylko za walutę gry",
    "couponOnlyDiamondCanUse" : "Tylko za diamenty",
    "couponOnlyPackageCanUse" : "Tylko za pakiety",
    "couponOnlySubCanUse" : "Tylko za subskrypcję",
    "couponOnlyDaibiCanUse" : "Tylko za tokeny",
    "couponMaxDiscount" : "Zniżka aż do \${price} \${currency}",
    "couponHasUsed" : "Użyto",
    "couponReductionType" : "Dedukcja",
    "couponDiscountType" : "Zniżka",
    "couponUseNow" : "Użyj",
    "couponHasNoSelect" : "Brak używania kuponu",
    "couponHasSelectQuan" : "Kwota zniżki",
    "couponSubmitTip" : "Kupony zostaną użyte",
    "couponCanUseQuan" : "Kupony",
    "couponOrderTotal" : "Suma",
    "couponHasDiscount" : "Zniżka",
    "couponPayTotal" : "Płatność",
    "couponCancel" : "Anuluj",
    "couponConfirm" : "Potwierdź",
    "uidLoginName" : "Log in with OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Enter your UID",
    "uidInputToken" : "Enter your OTP",
    "uidInputCode" : "Type the text",
    "uidTipTitle" : "Protect Your Account With OTP Verification",
    "uidTipHowToGet" : "How to get my one-time password?",
    "uidTipStep1" : "Step 1: Go to Settings > Account > User Center",
    "uidTipStep2" : "Step 2: Tap OTP",
    "uidTipstep3" : "Step 3: Copy and enter your UID and one-time password",
    "uidTipIntro1" : "1. One-time passwords expire in 60 seconds. Use them wisely to keep your account safe and secure.",
    "uidTipIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "couponMyQuan" : "Kupony",
    "couponSelectPaytypeTip" : "Wybierz kanał płatności i sprawdź info o zniżce",
    "couponSelectCouponTip" : "Wybierz kupony i sprawdź obniżoną cenę",
    "couponValidQuanTip" : "(Kupon x\${num} do ponownego użycia)",
    "couponLookCart" : "Koszyk",
    "couponUnfoldCart" : "Ukryj",
    "couponCoupon" : "Kupon",
    "couponNoUse" : "Nieużywane",
    "couponSelect" : "Wybierz kupon",
    "couponSureUse" : "Użyj",
    "couponReturn" : "Wróć",
    "couponInvalidTime" : "Wygasa",
    "couponBuyNow" : "Buy Now",
    "couponAllType" : "all",
    "ztmslgType1" : "Daily Sale",
    "ztmslgType2" : "Hero",
    "ztmslgType3" : "Battle Gear",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Resource",
    "ztmslgType8" : "Build Speedup",
    "ztmslgType9" : "Rare Items",
    "ztmslgType10" : "Alliance",
    "ztmslgType11" : "Diamond",
    "ztmslgType12" : "Module",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoweapon",
    "ztmslgType16" : "Grand Prize",
    "ztmslgType17" : "Rdzeń",
    "ztmslgType9999" : "Limited Offer",
    "ztmslgType10000" : "Gift Center",
    "ztmslgType10001" : "Holiday Events",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Daily Sale",
    "antslgType2" : "Specialized Ant",
    "antslgType3" : "Gear",
    "antslgType5" : "Gene",
    "antslgType6" : "Snail",
    "antslgType7" : "Resources",
    "antslgType8" : "Build & Research",
    "antslgType9" : "Rare Items",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamond",
    "antslgType12" : "Cell",
    "antslgType13" : "Totem",
    "antslgType9999" : "Limited Offer",
    "antslgTypeother" : "other",
    "typeall" : "Alle producten",
    "vipHead" : "Punkty VIP",
    "vipHead213": "Członkostwo Premium",
    "vipTitle" : "Wydarzenie pkt VIP",
    "nowLevel" : "Twój poziom:",
    "myVipScore" : "Twoje pkt:",
    "nextLevelNeed" : "(Zdobądź \${num} więcej pkt i zostań VIP \${level})",
    "ruleTitle" : "Zasady:",
    "ztmslgVipRule1" : "1. Wydarzenie rozpoczyna się o godzinie 00:00 (UTC) 2022/09/22",
    "ztmslgVipRule2" : "2. Dostępne gry:  Puzzles & Survival",
    "ztmslgVipRule3" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "ztmslgVipRule4" : "3. Wydarzenie Kuponu Logowania: podczas pierwszego logowania na stronie doładowania będzie można odebrać kupon, który oferuje 15% zniżki.",
    "ztmslgVipRule5" : "4. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "ztmslgVipRule6" : "5. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "ztmslgVipRule7" : "6. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "ztmslgVipRule8" : "7. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "ztmslgVipRule9" : "8. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "ztmslgVipRule10" : "9. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "ztmslgVipRule11" : "10. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "ztmslgVipRule12" : "11. Więcej szczegółów na temat poziomów VIP i kuponów znajduje się w poniższej tabeli.",
    "ztmslgVipRule13" : "12. W przypadku jakichkolwiek sporów, zespół wsparcia Puzzles & Survival ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "vipLevel" : "Poziom VIP",
    "vipCondition" : "Wymagane pkt",
    "firstSend" : "Pierwszy raz zdobycie prezentu",
    "weeklySend" : "Tygodniowy kupon",
    "lastAllCoupon" : "Kupony poprzedniego etapu",
    "besides" : "Tabela waluty/pkt:",
    "couponRatio" : "Przelicznik waluty/pkt",
    "backToPay" : "WRÓĆ",
    "quanGift" : "KUPON",
    "quanGiftTips" : "Masz kupon(y) do odebrania!",
    "antslgVipRule1" : "Z powodu aktualizacji funkcji, wydarzenie \"Punkty VIP\" zostanie wkrótce zakończone.",
    "antslgVipRule2" : "Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.",
    "antslgVipRule3" : "Czas zakończenia: 2024/09/28 00:00:00 (UTC)",
    "antslgVipRule4" : "Po zakończeniu wydarzenia możesz odwiedzić Centrum Członkostwa Premium, aby cieszyć się większą ilością korzyści:",
    "antslgVipRule5" : "Wykonuj zadania, aby zdobywać punkty, które można wymieniać na kupony, przedmioty w grze i inne nagrody! Korzystaj z ekskluzywnych korzyści dla członków i szczęśliwych losowań.",
    "antslgVipRule6" : "Bądź na bieżąco, aby poznać więcej nagród i wydarzeń!",
    "dzgVipRule0" : "1. Wydarzenie rozpoczyna się o godzinie 00:00 (UTC) 2022/09/27",
    "dzgVipRule1" : "1. Dostępne gry: \${gameName}",
    "dzgVipRule2" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "dzgVipRule3" : "2. Wydarzenie Kuponu Logowania: podczas pierwszego logowania na stronie doładowania będzie można odebrać kupon, który oferuje 15% zniżki.",
    "dzgVipRule4" : "3. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "dzgVipRule5" : "4. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "dzgVipRule6" : "5. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dzgVipRule7" : "6. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "dzgVipRule8" : "7. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "dzgVipRule9" : "8. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "dzgVipRule10" : "9. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "dzgVipRule11" : "10. Więcej szczegółów na temat poziomów VIP i kuponów znajduje się w poniższej tabeli.",
    "dzgVipRule12" : "11. W przypadku jakichkolwiek sporów, zespół wsparcia \${gameName} ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "213dzgVipRule1" : "Z powodu aktualizacji funkcji, wydarzenie \"Punkty VIP\" zostanie wkrótce zakończone.",
    "213dzgVipRule2" : "Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.",
    "213dzgVipRule3" : "Czas zakończenia: 2024/08/19 08:00:00 (UTC)",
    "213dzgVipRule4" : "Po zakończeniu wydarzenia możesz odwiedzić Centrum Członkostwa Premium, aby cieszyć się większą ilością korzyści:",
    "213dzgVipRule5" : "Wykonuj zadania, aby zdobywać punkty, które można wymieniać na kupony, przedmioty w grze i inne nagrody! Korzystaj z ekskluzywnych korzyści dla członków i szczęśliwych losowań.",
    "213dzgVipRule6" : "Bądź na bieżąco, aby poznać więcej nagród i wydarzeń!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Połącz/Rozłącz konto",
    "unbindApply" : "Odłącz",
    "unbindConfirmTitle" : "Na pewno chcesz odłączyć konto?",
    "unbindConfirmTip" : "Odłączenie konto może doprowadzić do utraty postępu/zapisu gry.",
    "unbindConfirm" : "Odłącz mimo to",
    "unbindExit" : "Wyjdź",
    "unbindSucc" : "Konto odłączone",
    "unbindFail" : "Nie udało się odłączyć konta. Prosimy o kontakt z naszym działem obsługi klienta.",
    "unbindServiceTitle" : "Zgłoś się po ręczną operację odłączenia.",
    "unbindContact" : "Dział obsługi klienta",
    "unbindServiceTip" : "Nie możesz odłączyć swojego konta. Prosimy o kontakt z naszym działem obsługi klienta.",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "Zapraszaj znajomych</br>Zdobywaj nagrody",
    "shareRule" : "Zasady",
    "awardBag" : "Moja nagroda",
    "initiatorText" : "To ja zapraszam",
    "inviteeText" : "To mnie zaproszono",
    "createCode" : "Stwórz kod zaproszenia",
    "createCodeTip" : "Stuknij, aby stworzyć kod zaproszenia",
    "createLinkTip" : "Stuknij, aby stworzyć link zaproszenia",
    "copyText" : "Skopiuj",
    "shareCode" : "Udostępnij kod zaproszenia",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Zobacz nagrodę",
    "seeAwardTip" : "Proszę sprawdzić swoje nagrody w <span class=\"see-light\">VIP Pkt</span> > <span class=\"see-light\">Mój kupon</span>.",
    "inviteReward" : "Nagroda zaproszenia",
    "inviteRewardTip" : "Zapraszający może odebrać te nagrody tylko wtedy, gdy każdy z zaproszonych osiągnie te cele po raz pierwszy",
    "overweightReward" : "Nagroda bonusowa",
    "resetTip" : "Resetuje się o 00:00 ostatniego dnia każdego miesiąca.",
    "rewardText1" : "Suma doładowań Zaproszonego: \$9.99",
    "rewardText2" : "Suma doładowań Zaproszonego: \$49.99",
    "rewardText3" : "Suma doładowań Zaproszonego: \$99.99",
    "rewardText4" : "Zdobądź kupon 12% ZNIŻKI x1 za każdych 5 zaproszonych graczy",
    "rewardText5" : "Zdobądź kupon 15% ZNIŻKI x1 gdy zaproszeni przez Ciebie doładują za sumę \$1000",
    "invitationList" : "Moje zaproszenie",
    "refresh" : "Odśwież",
    "invitedTotal" : "Zaproszono: \${total}",
    "storedTotal" : "Suma doładowania: \${total} USD",
    "people" : "",
    "invitedPeople" : "Zaproszony",
    "invitedTime" : "Zaproszono",
    "got" : "Osiągnięto",
    "get" : "Niezdobyte",
    "overlay" : "Do kumulacji",
    "couponText" : "Kupon",
    "personalReward" : "Nagroda doładowania",
    "personalRewardText1" : "Suma doładowania osiąga \$9.99",
    "personalRewardText2" : "Suma doładowania osiąga \$49.99",
    "personalRewardText3" : "Suma doładowania osiąga \$99.99",
    "inputCode" : "Wpisz kod zaproszenia",
    "bindCode" : "Potwierdź",
    "bindSucc" : "Powiązano",
    "codeTip1" : "Kod nie istnieje.",
    "codeTip2" : "Powiązano kod zaproszenia",
    "copySucc" : "Sukces!",
    "awardName" : "Nagroda",
    "getTime" : "Zdobyto",
    "getCondition" : "Wymaganie",
    "couponText1" : "Kupon 6% ZNIŻKI",
    "couponText2" : "Kupon 8% ZNIŻKI",
    "couponText3" : "Kupon 10% ZNIŻKI",
    "couponText4" : "Kupon 12% ZNIŻKI",
    "couponText5" : "Kupon 15% ZNIŻKI",
    "ruleText1" : "1. Czas rozpoczęcia wydarzenia: 2022/11/25, 00:00 UTC",
    "ruleText2" : "2. Gra wydarzenia: Puzzles & Survival",
    "ruleText3" : "3. Wydarzenie \"Udostępnianie oficjalnej strony doładowania\": Udostępnij tę oficjalną stronę doładowań swoim znajomym i zaproś ich do doładowania. Jeśli doładują określoną kwotę za pośrednictwem tej strony, otrzymasz nagrodę.",
    "ruleText4" : "4. Miesięczne nagrody z płatności osób trzecich: Osiągnij miesięczne cele udostępniania i wygraj nagrody. Nagrody za udostępnianie resetują się co miesiąc.",
    "ruleText5" : "5. Nagrody miesięczne wymagają co najmniej jednej udanej płatności za doładowanie na stronie trzeciej przez nowych graczy, których zaproszono.",
    "ruleText6" : "6. Nagrody miesięczne resetują się pierwszego dnia każdego miesiąca. To również resetuje wszelkie postępy z poprzedniego miesiąca.",
    "ruleText7" : "7. Nagrodzony kupon należy odebrać po zalogowaniu się na stronie doładowania strony trzeciej. Nie otrzymasz kolejnego kuponu, jeśli upłynął jego termin ważności.",
    "ruleText8" : "8. Kupon wykorzystuje tę samą walutę, której użyto w poprzednich udanych doładowaniach.",
    "ruleText9" : "9. Nie możesz użyć kodu zapraszającego innego gracza, jeśli on już użył Twojego.",
    "ruleTableTitle1" : "Zasady：",
    "ruleTableTitle2" : "Informacje o stopniach VIP i kuponach:",
    "ruleTableHead1" : "Wymaganie doładowania",
    "ruleTableHead2" : "Wymaganie nagród",
    "ruleTableHead3" : "Nagrody",
    "ruleTableContent1" : "Zaproś 5 nowych graczy",
    "ruleTableContent2" : "Zaproszeni gracze doładowują 1000 USD",
    "errorTip" : "Nieudana operacja",
    "eventShareText1" : "Puzzles & Survival Oferty limitowane",
    "eventShareText2" : "Czeka na Ciebie mnóstwo prezentów!",
    "cartDoubleTip" : "Mnożniki skrzyń nie wliczają się.",
    "codeTip3" : "Niezalogowany",
    "codeTip4" : "Brak parametru",
    "codeTip5" : "Nie można powiązać własnego kodu zaproszenia",
    "codeTip6" : "Utworzono kod zaproszenia",
    "payWelfare" : "Prezent doładowania",
    "wallet" : "Portfel",
    "myDiscount" : "Mój kupon",
    "knowMore" : "Więcej",
    "backPay" : "Powrót",
    "curBalance" : "Saldo",
    "pay" : "Doładowanie",
    "changeCoin" : "Zmień walutę",
    "watchDesc" : "Zobacz szczegóły",
    "getMore" : "Zdobądź więcej",
    "getDiscount" : "Zdobądź swoje kupony",
    "notOpenDiscountQuan" : "Brak wydarzeń. Bądź na bieżąco!",
    "abountZbit" : "O \${Z-BIT}",
    "remain" : "Pozostało:",
    "payRemain" : "Pozostała ilość po zakupie:",
    "payRemainExpiry" : "Po opłaceniu pozostanie około ${money} (Wygasa 1 stycznia 2026 r., prosimy o szybkie wykorzystanie)",
    "balanceNotEnoughExpiry" : "Niewystarczające saldo (Wygasa 1 stycznia 2026 r., doładowanie niemożliwe)",
    "balanceNotEnoggh" : "Niewystarczające saldo. Proszę najpierw doładować.",
    "goToPay" : "Doładowanie",
    "chooseOtherPay" : "Inne metody płatności",
    "payIntro" : "Szczegóły doładowania",
    "logRole" : "Wybierz postać",
    "chooseProduct" : "Wybierz przedmioty",
    "meAgree" : "Zapoznałem się i akceptuję warunki.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Weryfikacja dynamiczna jest wymagana przed użyciem \${Z-BIT}",
    "dl3dvnVipRule1" : "1. Dostępne gry: \${gameName}",
    "dl3dvnVipRule2" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "dl3dvnVipRule3" : "2. Wydarzenie Kuponu Logowania: podczas pierwszego logowania na stronie doładowania będzie można odebrać kupon, który oferuje 15% zniżki.",
    "dl3dvnVipRule4" : "3. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "dl3dvnVipRule5" : "4. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "dl3dvnVipRule6" : "5. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dl3dvnVipRule7" : "6. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "dl3dvnVipRule8" : "7. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "dl3dvnVipRule9" : "8. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "dl3dvnVipRule10" : "9. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "dl3dvnVipRule11" : "10. Więcej szczegółów na temat poziomów VIP i kuponów znajduje się w poniższej tabeli.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. W przypadku jakichkolwiek sporów, zespół wsparcia \${gameName} ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "codeTip7" : "Nie można użyć kodu gracza docelowego, ponieważ został już użyty",
    "ruleText10" : "10. Puzzles & Survival oficjalny zarząd zastrzega sobie wszelkie prawa do ostatecznej interpretacji.",
    "payCoins" : "Pkt VIP doładowania",
    "shareGift" : "Shae na prezenty",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "W wybranym regionie nie ma dostępnych metod płatności. Należy zmienić region i spróbować ponownie.",
    "dl3dtwVipRule1" : "1. Dostępne gry: \${gameName}",
    "dl3dtwVipRule2" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "dl3dtwVipRule3" : "2. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "dl3dtwVipRule4" : "3. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "dl3dtwVipRule5" : "4. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dl3dtwVipRule6" : "5. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "dl3dtwVipRule7" : "6. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "dl3dtwVipRule8" : "7. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "dl3dtwVipRule9" : "8. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "dl3dtwVipRule10" : "9. Więcej szczegółów na temat poziomów VIP i kuponów znajduje się w poniższej tabeli.",
    "dl3dtwVipRule11" : "10. W przypadku jakichkolwiek sporów, zespół wsparcia \${gameName} ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "eventInviteSucc" : "Dodaj Pomyślnie Znajomego",
    "eventGainCondition" : "Wymagania",
    "eventSuccInvite" : "Dodaj pomyślnie znajomego",
    "eventInviteGainOne" : "Suma doładowań \nZaproszonego: \$49.99",
    "eventInviteGainTwo" : "Suma doładowań \nZaproszonego: \$99.99",
    "eventFriendCode" : "Kod Twojego Znajomego:",
    "eventCheckBind" : "Powiązać?",
    "eventConfirm" : "Potwierdź",
    "eventCancel" : "Anuluj",
    "eventBindSucc" : "Pomyślnie powiązano!",
    "eventGainCoupon" : "Otrzymano kupon.",
    "eventLookCoupon" : "Zobacz kupon",
    "eventSuccBind" : "Pomyślnie powiązano",
    "recaptchaTip" : "Najpierw zweryfikuj",
    "inputAccountName" : "Wpisz nazwę konta, które chcesz odzyskać",
    "pwaPayTip" : "Szybki dostęp, lepsze doświadczenie",
    "pwsInstall" : "Dodaj do ekranu startowego",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Po zakupie vouchery zostaną wysłane do Twojej skrzynki pocztowej w grze. Vouchery mogą być wykorzystane do zakupu przedmiotów w Sklepie voucherów w grze. Vouchery użyte do zakupu przedmiotów będą wliczane do Twojego całkowitego doładowania.",
    "notice" : "Informacja",
    "popupConfirm" : "Potwierdź",
    "hideWithinWeek" : "Nie pokazuj ponownie przez 7 dni",
    "ztmslgProductOffTips" : "Otrzymaliśmy wiele cennych opinii na temat zmian na stronie płatności, które miały zostać wprowadzone 13 marca. Odpowiadając na to, postanowiliśmy zrezygnować z tych zmian i skupimy się na poprawieniu Waszych doświadczeń związanych z zakupami. Doceniamy Wasze opinie i dziękujemy za zrozumienie i wsparcie. Jeśli pojawią się kolejne pytania, zapraszamy do kontaktu z naszym Zespołem Wsparcia.",
    "couponTopLimit" : "Maksymalne wartości odliczeń według waluty",
    "swsjpVipRule1" : "1. Wydarzenie rozpoczyna się o godzinie 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2. Dostępne gry: \${gameName}",
    "swsjpVipRule3" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "swsjpVipRule4" : "3. Wydarzenie Kuponu Logowania: podczas pierwszego logowania na stronie doładowania będzie można odebrać kupon, który oferuje 15% zniżki.",
    "swsjpVipRule5" : "4. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "swsjpVipRule6" : "5. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "swsjpVipRule7" : "6. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "swsjpVipRule8" : "7. Punkty za dokonane wcześniej zakupy są już przyznawane.",
    "swsjpVipRule9" : "8. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "swsjpVipRule10" : "9. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "swsjpVipRule11" : "10. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "swsjpVipRule12" : "11. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "swsjpVipRule13" : "12. W przypadku jakichkolwiek sporów, zespół wsparcia \${gameName} ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucer",
    "passAskMods" : "Zapytaj Moda",
    "passAskModsTip" : "Zadawaj Moderatorom wszelkie pytania dotyczące gry",
    "passService" : "Pytania Klienta",
    "passServiceTip" : "Wszelkie pytania dotyczące konta i doładowania prosimy kierować do naszego działu wsparcia i obsługi klienta.",
    "passIKonw" : "OK",
    "passGoOn" : "Kontynuuj",
    "voucherTitle" : "Oficjalne Centrum Doładowań",
    "voucherAddHome" : "Dodaj do pulpitu",
    "voucherAddHomeTipOne" : "Szybsza płatność, lepsze doświadczenie",
    "voucherAddHomeTipTwo" : "Stuknij [Udostępnij] w pasku narzędzi",
    "voucherAddHomeTipThree" : "Wybierz [Dodaj do pulpitu]",
    "voucherLoginLook" : "Zaloguj się i zobacz oferty",
    "voucherSwitchRole" : "Zmień postać",
    "voucherCoupon" : "Kupon",
    "voucherVip" : "Pkt VIP",
    "voucherMoreCoupon" : "Więcej ofert",
    "voucherAccountId" : "ID Konta",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Wybierz inny sposób płatności",
    "voucherOtherLoginWay" : "Spróbuj innym sposobem",
    "voucherCouponActivity" : "Wyprzedaże ze zniżką",
    "voucherActivityNotBegin" : "Wydarzenie jeszcze się nie zaczęło.",
    "voucherGoCommunity" : "Dowiedz się więcej o korzyściach z doładowania w społeczności",
    "voucherValidTime" : "Ważność",
    "voucherLimitRegion" : "Tylko dla \${currency}",
    "voucherLiuyi" : "Brak dostępnych kuponów. Uprzejmie prosimy o śledzenie przyszłych wydarzeń.",
    "voucherPay" : "Kup vouchery",
    "voucherAbout" : "O voucherach",
    "voucherChooseWay" : "Wybierz metodę płatności",
    "voucherMoreWay" : "Więcej metod płatności",
    "voucherChooseCoupon" : "Wybierz kupon",
    "voucherHasChoose" : "Wybrano",
    "voucherMoneyInsufficient" : "Niewystarczające saldo",
    "voucherContact" : "Niewystarczające saldo. Prosimy o kontakt z naszym zespołem wsparcia.",
    "voucherCouponTotal" : "Dostępne kupony",
    "voucherCouponTipGuide" : "Kupony można wykorzystać do płatności po wybraniu kanału płatności.",
    "voucherPaytypeNotSupport" : "Kupony są niedostępne dla tego kanału płatności",
    "voucherTipSideOne" : "Vouchery mogą być wymieniane na wszystkie pakiety w grze i usługi o wartości dodanej, z wyjątkiem samego vouchera.",
    "voucherTipSideTwo" : "Do 15% zniżki",
    "voucherYue" : "Saldo",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Poradnik Przetrwania",
    "vipHeadText" : "Odblokowano ekskluzywną ramkę VIP",
    "vipHeadGetText" : "Odbierz",
    "vipHeadGotText" : "Odebrano",
    "vipHeadGetTitle" : "Potwierdź",
    "vipHeadGetTip" : "Ta nagroda może być odebrana tylko raz na jednym koncie. Kontynuować?",
    "vipHeadAwardText" : "Elitarny Dowódca (na stałe)",
    "vipHeadGetErrTip1" : "Niepomyślna próba. Spróbuj ponownie lub skontaktuj się z CS.",
    "cartGuideTipNew" : "Dodaj więcej przedmiotów, aby użyć kuponu",
    "newVipTitle" : "Centrum doładowania VIP",
    "newVipLogin" : "ZALOGUJ",
    "newVipNowPoint" : "Punkty:",
    "newVipNextLevel" : "\${point} punktów do następnego poziomu",
    "newVipUpgrade" : "ULEPSZ",
    "newVipLevel" : "Przywileje VIP",
    "newVipTip" : "Kupony będą odświeżane w każdą sobotę o godzinie 00:00 (UTC). Otrzymasz je po zalogowaniu się na oficjalnej stronie doładowania.",
    "newVipWeekly" : "Podarunek tygodnia",
    "newVipReachPoint" : "Wymagania:",
    "newVipRuleInfo" : "Zasady:",
    "pleaseLang" : "Język",
    "reference" : "Numer zamówienia",
    "saveToNext" : "Zapisz informacje o karcie kredytowej.",
    "cardNum" : "Numer karty",
    "expireTime" : "Ważna do",
    "CVV" : "CVV",
    "pleaseCard" : "Rodzaj karty kredytowej",
    "howToPay" : "Jak chcesz zapłacić?",
    "checkCard" : "Sprawdź numer swojej karty.",
    "checkExpiryDate" : "Sprawdź datę ważności karty.",
    "checkCVV" : "Sprawdź CVV swojej karty.",
    "addCard" : "Nowa",
    "delete" : "Usuń",
    "deleteCardTips" : "Usuń zapisane informacje o karcie kredytowej.",
    "confirmDelete" : "Tak, usuń",
    "cancelDelete" : "Anuluj",
    "checkAllCardMsg" : "Upewnij się, że wprowadzono prawidłowy numer karty, datę ważności oraz CVV.",
    "leaveCreditPageTips" : "Transakcja nie zostanie sfinalizowana, jeśli teraz opuścisz tę stronę. Opuścić mimo to?",
    "sureToLeave" : "Wyjdź",
    "continueToPay" : "Kontynuuj",
    "pushTest" : "Test powiadomień",
    "getNoticication" : "Nie otrzymujesz powiadomień o grze?",
    "waitCheckResult" : "Poczekaj na wynik testu.",
    "hadAbnormal" : "Znaleziono anomalię, która może prowadzić do niepowodzenia powiadomienia.",
    "clickIntro" : "Stuknij w raport, aby zobaczyć rozwiązanie",
    "networkCheck" : "Test sieci",
    "noticeAuthorityCheck" : "Test dostępu do powiadomień",
    "noticeBtnCheck" : "Test paska powiadomień",
    "gmsCheck" : "Test usługi GMS",
    "batteryCheck" : "Test listy optymalizacji baterii",
    "pushServiceCheck" : "Test usługi powiadomień",
    "reCheck" : "Przetestuj ponownie",
    "noNoticeAuthorityTip" : "Dostęp do powiadomień nie został przyznany na tym urządzeniu. Przejdź do Ustawień systemowych - Powiadomienia, aby przyznać dostęp do gry.",
    "noNoticeBtnTip" : "Pasek powiadomień jest wyłączony. Należy go włączyć w Ustawieniach systemu.",
    "noBatteryTip" : "Gra znajduje się na liście optymalizacji baterii, możesz nie otrzymywać powiadomień. Przejdź do Ustawienia systemowe - Bateria - Optymalizacja baterii, aby dodać grę do białej listy.",
    "noPushServiceTip" : "Serwer powiadomień nie jest połączony. Stuknij [Połącz], aby wznowić usługę.",
    "noNetworkTip" : "Obecne połączenie sieciowe jest niestabilne.",
    "noGmsTip" : "Twoje urządzenie nie obsługuje GMS. Użyj urządzenia kompatybilnego z GMS.",
    "pushConnectFail" : "Serwer powiadomień rozłączony.",
    "pushConnectSucc" : "Serwer powiadomień połączony.",
    "noGetPushTitle" : "Jeśli nadal nie możesz otrzymywać powiadomień z gry. Wykonaj następujące kroki:",
    "noGetPushContOne" : "1. Wyloguj się z gry, a następnie zaloguj się ponownie na tym urządzeniu.",
    "noGetPushContTwo" : "2. Stuknij [Test powiadomień], aby sprawdzić, czy aktualnie używane urządzenie może odbierać powiadomienia testowe.",
    "noGetPushContThree" : "3. Jeśli otrzymałeś powiadomienie testowe, ale nadal nie możesz otrzymywać żadnych innych powiadomień, zaloguj się do gry, przejdź do Ustawienia - Powiadomienia i sprawdź, czy wszystkie powiadomienia są włączone.",
    "noGetPushContFour" : "4. Jeśli nadal nie możesz otrzymywać żadnych powiadomień, skontaktuj się z naszym działem obsługi klienta.",
    "getPushSucc" : "Urządzenie otrzymało powiadomienie testowe. Funkcja działa poprawnie!",
    "allCheckSucc" : "Test powiadomienia został przeprowadzony. Nie znaleziono żadnych anomalii!",
    "pushCheck" : "Test powiadomień",
    "useDirectPay" : "Użyj ekspresowej płatności",
    "paypalFraudnetInfo" : "Bezpieczna płatność przez PayPal",
    "goToSetting" : "Ustawienia",
    "retry" : "Ponów",
    "connect" : "Połącz",
    "canRebind" : "Możesz powiązać znowu po odwiązaniu",
    "agreePlatform" : "Zgadzam się na \${service} oraz \${privite}.",
    "sendGameNews" : "Zapisz się do newslettera.",
    "canNotBindEmail" : "Po odwiązaniu nie będzie można używać tego adresu e-mail do logowania.",
    "canNotBindPhone" : "Po odwiązaniu nie będzie można używać tego nr telefonu do logowania.",
    "canChangeByEmail" : "Możesz zalogować się za pomocą e-mail na innych urządzeniach.",
    "canChangeByPhone" : "Możesz zalogować się za pomocą nr telefonu na innych urządzeniach.",
    "loginSucc" : "Zalogowano",
    "phoneHadBind" : "Ten nr telefonu został już powiązany. Zalogować się za jego pomocą?",
    "emailHadBind" : "Ten email został już powiązany. Zalogować się za jego pomocą?",
    "phoneNotBind" : "Ten nr telefonu nie jest powiązany. Utworzyć nowe konto?",
    "emailNotBind" : "Ten e-mail nie jest powiązany. Utworzyć nowe konto?",
    "emailAccount" : "Konto e-mail",
    "phoneAccount" : "Konto nr telefonu",
    "phoneInputError" : "Nieprawidłowy numer tel. komórkowego",
    "registerNewAccount" : "Rejestracja",
    "secureTip" : "Account Safety Tips",
    "toTop" : "Przypnij do góry",
    "createNewWork" : "Nowe zgłoszenie",
    "serviceEvaluate" : "Oceń usługę",
    "emailRemind" : "Powiadomienia",
    "isAgreeService" : "Jak ci się podoba nasza usługa?",
    "thankEvaluateTop" : "Dziękujemy za Twoją opinię!",
    "inputValidEmail" : "Wpisz prawidłowy adres e-mail.",
    "replyWillRemind" : "Otrzymasz powiadomienie e-mail, gdy odpowiedź na Twoje pytanie zostanie udzielona. Stuknij ponownie, aby je wyłączyć.",
    "isCancelEmailRemind" : "Nie otrzymasz żadnej wiadomości e-mail z powiadomieniem. Wyłączyć mimo to?",
    "reconfirmEmail" : "Potwierdź swój adres e-mail.",
    "confirmCanSubmit" : "Potwierdź przesłanie zgłoszenia",
    "serviceWillReply" : "Zostaniesz powiadomiony e-mailem, gdy obsługa klienta udzieli odpowiedzi.",
    "cancelEmailRemind" : "Wyłączyć [Powiadomienia]?",
    "yes" : "Tak",
    "no" : "Nie",
    "inputWorkSearch" : "Szukaj...",
    "loading" : "Ładowanie",
    "loadingError" : "Nie udało się załadować. Załaduj ponownie...",
    "noMore" : "Nic więcej",
    "cancelToTop" : "Odepnij",
    "evaluateOne" : "Bardzo źle",
    "evaluateTwo" : "Źle",
    "evaluateThree" : "Neutralnie",
    "evaluateFour" : "Dobrze",
    "evaluateFive" : "Bardzo dobrze",
    "confirmDelWorkTop" : "Usunąć to zgłoszenie?",
    "reRemindEmail" : "Potrzebujesz powiadomienia e-mail? Wystarczy ponownie dotknąć przycisku [Powiadomienia].",
    "confirmWillReply" : "Potwierdź, aby wyrazić zgodę na otrzymywanie powiadomień e-mailem o odpowiedzi działu obsługi klienta.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Usuniętego zgłoszenia nie można odzyskać.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Wideo przesłane",
    "videoUploadFail" : "Nie udało się przesłać wideo",
    "videoUploadLimit" : "Prosimy o przesyłanie plików mp4 o rozmiarze poniżej 400 MB i nie dłuższych niż 2 minuty.",
    "imageUploadSucc" : "Przesłane zdjęcie",
    "imageUploadFail" : "Nie udało się przesłać zdjęcia",
    "uploading" : "Przesyłanie",
    "smartOrderCreate" : "Szybki bilet",
    "smartOrderSearch" : "Szukaj",
    "smartOrderComing" : "Już wkrótce",
    "smartOrderContactService" : "Obsługa klienta",
    "smartOrderDetector" : "Asystent",
    "smartOrderDetect" : "Diagnoza",
    "smartOrderDetecting" : "W trakcie diagnozy",
    "smartOrderDetectTip" : "Podczas gry wykryto błąd. Dotknij opcji Diagnoza, abyśmy mogli go zidentyfikować.",
    "smartOrderDetectTip2" : "Zidentyfikowano problem. Prześlij zgłoszenie, abyśmy mogli go rozwiązać!",
    "smartOrderSubmit" : "Prześlij",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Zobacz",
    "smartOrderIsHelp" : "Czy ten artykuł był pomocny?",
    "smartOrderInputQuestion" : "Zapisz napotkany problem.",
    "smartOrderPleaseInpt" : "Wpisz",
    "smartOrderPleaseChoose" : "Wybierz",
    "smartOrderStoreTime" : "Czas doładowania",
    "smartOrderInputOrder" : "Wpisz numer zamówienia",
    "smartOrderInputPrice" : "Wpisz kwotę zamówienia",
    "smartOrderNeedHelp" : "W czym mogę pomóc?",
    "smartOrderLookHelpTip" : "Możesz sprawdzić w najczęściej zadawanych pytaniach.",
    "smartOrderNoResult" : "Brak wyników. Spróbuj innej frazy.",
    "smartOrderUpdateTime" : "Ostatni czas edycji",
    "smartOrderSelectStoreTime" : "Wybierz czas doładowania",
    "smartOrderAtlestChoose" : "Wypełnij przynajmniej jedno pole",
    "pwaInstallAward" : "Dodaj skrót",
    "getMasonry" : "Odbierz diament",
    "addToDrawerVisit" : "Dodaj skrót, aby łatwo go znaleźć.",
    "immeAddToGet" : "Dodaj skrót teraz, aby odebrać limitowane nagrody.",
    "add" : "Dodaj skrót",
    "talkNextTime" : "Później",
    "chooseRoleGetGift" : "Wybierz postać, aby odebrać nagrody",
    "getGiftSuccess" : "Odebrano. Sprawdź swoje nagrody w grze.",
    "dmaTitle" : "Spersonalizowane reklamy",
    "newAdd" : "Nowa",
    "smartDelete" : "Usuń",
    "wordLengthTip" : "(0-600 znaków)",
    "areaLimitSwitchRegion" : "Zmień region",
    "areaLimitCurrentRegionCurrency" : "Obecny region i waluta",
    "areaLimitRegion" : "Region:",
    "areaLimitCurrency" : "Waluta:",
    "areaLimitNote" : "Uwaga:",
    "areaLimitSwitchLimitation" : "Każde konto może zmienić region raz na rok.",
    "areaLimitPostSwitchCoupon" : "Po zmianie regionu waluta nowych kuponów zostanie odpowiednio zmieniona.",
    "areaLimitRemainingSwitches" : "Pozostałe próby zmiany: \${times}",
    "areaLimitNoRemainingSwitches" : "Brak prób zmiany",
    "areaLimitUnableToSwitchThisYear" : "W tym roku nie możesz już zmienić regionu.",
    "areaLimitCannotSwitch" : "Nie można zmienić",
    "areaLimitNavigateToSwitch" : "Zmień",
    "areaLimitConfirmSwitch" : "Potwierdź",
    "areaLimitPreSwitchRegionCurrency" : "Obecny region i waluta",
    "areaLimitPostSwitchRegionCurrency" : "Nowy region i waluta",
    "areaLimitPostSwitchRestriction" : "Po wykonaniu tej czynności nie można już zmienić regionu w tym roku.",
    "areaLimitUnusedZBitWarning" : "Masz niewykorzystany Z-Bit, który nie może być używany po zmianie regionu. Mimo to kontynuować?",
    "areaLimitConfirm" : "Potwierdź",
    "areaLimitCancel" : "Anuluj",
    "areaLimitInconsistencyWarning" : "Region dostępu jest niezgodny z regionem płatności.",
    "areaLimitPromptToSwitch" : "Czy chcesz zmienić region?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Odbierz nagrodę",
    "selectProductTitle" : "Wybierz przedmiot",
    "hotSuggest" : "Gorㅁㅊㅁ",
    "inputKeywordSearch" : "Szukaj...",
    "lookProductContent" : "Szczegóły",
    "popupClose" : "Zamknij",
    "productSwitch" : "Zmień",
    "confirmBuy" : "Kup",
    "thinkLater" : "Później",
    "areaLimitConfirmRegion" : "Potwierdź region",
    "areaLimitContinuePay" : "Kontynuuj płatność",
    "areaLimitSwitchLimitationTwice" : "Każde konto może zmienić region dwa razy w roku.",
    "dtmslgVipRule1" : "1. Dostępne gry: \${gameName}",
    "dtmslgVipRule2" : "Każdy rodzaj nagrody za wydarzenie może być odebrany tylko raz.",
    "dtmslgVipRule3" : "2. Impreza VIP punkty: zakup przedmiotu za pośrednictwem naszej oficjalnej strony, aby zdobyć punkty i uzyskać kupony poziomu i tygodniowe kupony.",
    "dtmslgVipRule4" : "3. Punkty, które możesz zdobyć mogą się różnić w zależności od waluty, której używasz. Aby uzyskać więcej szczegółów, proszę sprawdzić link na dole.",
    "dtmslgVipRule5" : "4. When using coupons, you will earn points based on the amount you\'ve paid after coupons are deducted.",
    "dtmslgVipRule6" : "5. Zdobyte przez Ciebie punkty wygasną za 365 dni. Może to wpłynąć na Twój poziom VIP.",
    "dtmslgVipRule7" : "6. Natychmiast otrzymasz kupon za osiągnięcie poziomu VIP po raz pierwszy. Kupon tygodniowy będzie można odebrać w każdą sobotę o godzinie 00:00 (UTC+0).",
    "dtmslgVipRule8" : "7. Aby odebrać cotygodniowy kupon, musisz się zalogować. Nie przegap!",
    "dtmslgVipRule9" : "8. Walutą kuponu będzie waluta ostatniego dokonanego przez Ciebie zamówienia. Prosimy o kontakt z naszym działem obsługi klienta, jeśli chcesz zmienić używaną walutę.",
    "dtmslgVipRule10" : "9. Więcej szczegółów na temat poziomów VIP i kuponów znajduje się w poniższej tabeli.",
    "dtmslgVipRule11" : "10. W przypadku jakichkolwiek sporów, zespół wsparcia \${gameName} ma wyłączne i ostateczne prawo do interpretacji niniejszego regulaminu.",
    "dtmslgType10010" : "Daily Discount",
    "dtmslgType10020" : "Limited Offer",
    "dtmslgType10030" : "Hero",
    "dtmslgType10040" : "Gear",
    "dtmslgType10050" : "Rune Challenge",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Holystone",
    "dtmslgType10080" : "Dragon",
    "dtmslgType10090" : "Resource",
    "dtmslgType10100" : "Build & Tech",
    "dtmslgType10110" : "Rare",
    "dtmslgType10120" : "Curio",
    "dtmslgType10130" : "Diamond",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Event Pack",
    "dtmslgType3" : "Rewards Center",
    "dtmslgType4" : "Pop-Up Pack",
    "dtmslgType5" : "Main Screen Pack",
    "dtmslgType20010" : "Black Friday Pack",
    "dtmslgType20021" : "5-Day Gift",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Z powodu aktualizacji funkcji, wydarzenie \"Punkty VIP\" zostanie wkrótce zakończone.<br/>\n" +
        "Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.<br/>\n" +
        "Czas zakończenia: 2024/08/19 08:00:00 (UTC)<br/>\n" +
        "Po zakończeniu wydarzenia możesz odwiedzić Centrum Członkostwa Premium, aby cieszyć się większą ilością korzyści:<br/>\n" +
        "Wykonuj zadania, aby zdobywać punkty, które można wymieniać na kupony, przedmioty w grze i inne nagrody! Korzystaj z ekskluzywnych korzyści dla członków i szczęśliwych losowań.<br/>\n" +
        "Bądź na bieżąco, aby poznać więcej nagród i wydarzeń!",
    "263RightsIntro": "Z powodu aktualizacji funkcji, wydarzenie \"Punkty VIP\" zostanie wkrótce zakończone.<br/>\n" +
        "Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.<br/>\n" +
        "Czas zakończenia: 2024/09/28 00:00:00 (UTC)<br/>\n" +
        "Po zakończeniu wydarzenia możesz odwiedzić Centrum Członkostwa Premium, aby cieszyć się większą ilością korzyści:<br/>\n" +
        "Wykonuj zadania, aby zdobywać punkty, które można wymieniać na kupony, przedmioty w grze i inne nagrody! Korzystaj z ekskluzywnych korzyści dla członków i szczęśliwych losowań.<br/>\n" +
        "Bądź na bieżąco, aby poznać więcej nagród i wydarzeń!",
    "goToRights" : "Udaj się do Centrum Członków Premium",
    "oldVipIntro" : "Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.",
    "pwa-20001" : "Najpierw się zaloguj",
    "pwa-20002" : "Nieprawidłowy parametr",
    "pwa-20003" : "Proszę wskazać postać",
    "pwa-20004" : "Nie udało się wysłać nagród. Spróbuj ponownie lub skontaktuj się z Działem Obsługi Klienta.",
    "pwa-20005" : "Już odebrano nagrodę.",
    "pwa-20100" : "Wydarzenie nie rozpoczęło się.",
    "pwa-20101" : "Wydarzenie się zakończyło.",
    "pwa-20102" : "Nie możesz jeszcze odebrać nagród.",
    "pwa-20103" : "Twoje nagrody wygasły.",
    "pwa-1001" : "Zbyt częsta operacja",
    "pwaCommon" : "Spróbuj ponownie później!",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Oficjalne centrum doładowań",
    "headerSafeTip": "Bezpiecznie i bez ryzyka Natychmiastowa transakcja",
    "safeChecking": "...skanowanie obecnego środowiska płatności",
    "safeChecked": "Bezpieczne i pewne w użyciu",
    "riskChecked": "Wykryto potencjalne ryzyko, należy zachować ostrożność",
    "footerSafeTitle1": "Bezpieczne",
    "footerSafeTitle2": "Wygodne",
    "footerSafeTitle3": "Ekonomiczne",
    "footerSafeTitle4": "Wydajne",
    "footerSafeContent1": "Oficjalne centrum doładowań",
    "footerSafeContent2": "Obsługa wielu metod płatności",
    "footerSafeContent3": "Oferty rabatowe, więcej korzyści ograniczonych czasowo",
    "footerSafeContent4": "Natychmiastowa transakcja, bez opóźnień",
    "limitedTimeActivityTitle" : "Time-Limited Benefits",
    "limitedTimeActivityTime" : "Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Currently \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Exchange rates may vary, please refer to this page for accurate information)",
    "limitedTimeActivityNotAchieve" : "Not Completed",
    "limitedTimeActivityClaim" : "Claim",
    "limitedTimeActivityClaimed" : "Claimed",
    "limitedTimeActivityTimeLeft" : "Time-Limited: \${days}d \${hours}h \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Claim Records",
    "limitedTimeActivityAward" : "Rewards",
    "limitedTimeActivityGotTime" : "Time Claimed",
    "limitedTimeActivityGotRole" : "Character Claimed",
    "limitedTimeActivityRule" : "Event Rules",
    "limitedTimeActivity285Rule1" : "1. Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. During the event, complete time-limited tasks to claim rewards. Tasks are categorized into weekly and monthly tasks:",
    "limitedTimeActivity285Rule3" : "(1) Weekly Tasks: Each account is limited to completing one weekly task a week, resetting every Monday at 0:00.",
    "limitedTimeActivity285Rule4" : "Weekly Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule5" : "Top up any amount: Within the limited time, top up any amount via the official website.",
    "limitedTimeActivity285Rule6" : "(2) Monthly Tasks: Each account is limited to one monthly task a month, resetting on the 1st of each month at 0:00.",
    "limitedTimeActivity285Rule7" : "Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule8" : "Accumulative Top Up Task: Within the limited time, top up the required amount to claim a reward once.",
    "limitedTimeActivity285Rule9" : "Note: Due to the long duration of the event, exchange rates may fluctuate. Please refer to the displayed amount on the page for the top up amount.",
    "limitedTimeActivity285Rule10" : "3. Select a character before claiming a reward. You can find your rewards in-game after claiming them.",
    "limitedTimeActivityClaimAward" : "Claim Reward",
    "limitedTimeActivityConfirmGot" : "Confirm Claim",
    "limitedTimeActivityGetSucc" : "Claim Successful",
    "limitedTimeActivityGetFail" : "Claim Failed. Please try again later or contact customer service.",
    "limitedTimeActivityFrequent" : "Please avoid frequent actions.",
    "limitedTimeActivityLoginFirst" : "Please log in first.",
    "limitedTimeActivityWrongParam" : "Parameter Error",
    "limitedTimeActivityOverTips" : "The event has expired. Please refresh the page.",
    "preRightsIntro" : "Z powodu aktualizacji funkcji, wydarzenie \"Punkty VIP\" zostanie wkrótce zakończone.<br/>Czas zakończenia: \${offLineDate}<br/>Prosimy o upewnienie się, że wykorzystasz kupony otrzymane z wydarzenia \"Punkty VIP\" zanim wygasną.<br/>Po zakończeniu wydarzenia możesz odwiedzić Centrum Członkostwa Premium, aby cieszyć się większą ilością korzyści:<br/>Wykonuj zadania, aby zdobywać punkty, które można wymieniać na kupony, przedmioty w grze i inne nagrody! Korzystaj z ekskluzywnych korzyści dla członków i szczęśliwych losowań.<br/>Bądź na bieżąco, aby poznać więcej nagród i wydarzeń!",
    "riskTipTitle" : "Uważaj na bezprawne zachowania i oszustwa",
    "riskTipContent" : "Drogi Graczu,\n\nZauważyliśmy, że niektórzy gracze podejmują działania zakłócające porządek i uczciwość gry. Do najczęstszych naruszeń należą:\n\n1. Publikowanie Nieautoryzowanych Reklam: Udostępnianie nieautoryzowanych reklam przez czat w grze lub inne kanały, takie jak promowanie nielegalnego handlu zasobami lub nieautoryzowanych doładowań.\n2. Używanie Cheatów lub Skryptów: Korzystanie z cheatów, skryptów lub innych środków technicznych w celu nielegalnego pozyskiwania zasobów.\n3. Nieautoryzowane Zaproszenia: Wysyłanie zaproszeń podczas czatu w celu nakłaniania graczy do kontaktu przez zewnętrzne kanały (np. Line, Discord).\n4. Nielegalne Doładowania: Promowanie nieoficjalnych doładowań po obniżonych cenach w celu zwabienia graczy.\n5. Inne Oszustwa: Angażowanie się w działalność oszukańczą, taką jak podszywanie się pod oficjalnych pracowników.\n\nApelujemy do wszystkich graczy o ochronę swoich danych osobowych i zasobów. Nie ufaj żadnym nielegalnym lub związanym z oszustwami wiadomościom. Te naruszenia wiążą się z poważnym ryzykiem, w tym możliwością kradzieży konta lub zaangażowania w działalność oszukańczą. Prosimy pamiętać, że nie zapewniamy rekompensaty za straty wynikające z takich działań.\n\nW przypadku kont, które angażują się w takie zachowania, podejmiemy odpowiednie działania w zależności od stopnia i wpływu naruszeń. Środki mogą obejmować, ale nie są ograniczone do, ostrzeżeń, konfiskaty nielegalnych zysków, tymczasowych zawieszeń lub trwałych zakazów. Jeśli napotkasz jakiekolwiek podejrzane zachowanie w grze, zgłoś je do naszego zespołu obsługi klienta. Zbadamy sprawę tak szybko, jak to możliwe, i podejmiemy niezbędne środki. Dziękujemy za zrozumienie i wsparcie.",
    "linkValid": "Ten link wygasł",
    "-" : "-",
    "accountLabel": "Konto",
    "passwordLabel": "Hasło",
    "confirmPasswordLabel": "Potwierdź hasło",
    "confirmDeleteTitle" : "Czy na pewno chcesz usunąć swoje konto i wszystkie postacie?",
    "confirmDeleteYes" : "Tak. Chcę usunąć swoje konto i wszystkie postacie.",
    "selectGame" : "Wybierz grę",
    "confirmDeleteNo" : "Nie. Chcę usunąć tylko postać. Chciałbym zachować swoje konto.",
    "delTermsTitle" : "Proszę uważnie przeczytać wymagania i informacje dotyczące usuwania konta.",
    "delCondTitle" : "1. Wymagania dotyczące usuwania konta",
    "delCond1" : "(1) Proszę zalogować się na swoje konto przed złożeniem wniosku. Jeśli nie możesz się zalogować, proszę najpierw [odzyskać swoje konto]. Upewnij się, że konto gry i postać należą do Ciebie.",
    "delCond2" : "(2) Proszę potwierdzić, że Twoje konto i postać nie mają <span>żadnych zagrożeń bezpieczeństwa</span>, w tym nierozwiązanych skarg, raportów, dochodzeń, arbitraży ani pozwów (złożonych przez Ciebie lub przeciwko Tobie).",
    "delCond3" : "(3) Proszę potwierdzić, że Twoje konto i postać nie mają <span>żadnych zaległych płatności</span>, w tym nierozliczonych zwrotów lub aktywnych subskrypcji.",
    "delNoticeTitle" : "2. Powiadomienie o usunięciu konta",
    "delNotice1" : "(1) Usunięcie tego konta gry i powiązanych z nim postaci będzie <span>trwałe i nieodwracalne</span>.",
    "delNotice2" : "(2) Prosimy o <span>uregulowanie wszystkich zaległych zasobów w grze</span>, w tym, ale nie tylko, przedmiotów, waluty i subskrypcji, przed przystąpieniem do usuwania konta, ponieważ zostaną one trwale usunięte. Zwroty za usunięte konta lub postacie nie będą wydawane po zamknięciu serwera gry.",
    "delNotice3" : "(3) Usunięcie danych konta i postaci spowoduje również usunięcie lub zanonimizowanie wszystkich powiązanych informacji. Jednak konieczne będzie ręczne odłączenie i zarządzanie danymi powiązanymi z logowaniem za pomocą mediów społecznościowych stron trzecich (np. Facebook).",
    "delNotice4" : "(4) Dla ochrony Twoich interesów przewidziano 14-dniowy okres oczekiwania (Okres Odstąpienia), w którym możesz skontaktować się z działem wsparcia w celu anulowania wniosku o usunięcie konta (chyba że lokalne przepisy stanowią inaczej).",
    "delNotice5" : "(5) Po pomyślnym przesłaniu wniosku Twoje konto zostanie natychmiast zamrożone, ale proces usuwania danych może potrwać do tygodnia. Po zakończeniu otrzymasz powiadomienie e-mail.",
    "delFormConfirm1" : "Rozumiem warunki i konsekwencje usunięcia konta.",
    "delFormConfirm2" : "To konto nie ma żadnych nierozstrzygniętych zgłoszeń ani sporów prawnych.",
    "delForm" : "Przeczytałem i zgadzam się z <a class=\"account-delete-link\" href=\"javascript:;\">Umową o Usunięcie Konta</a>.",
    "cannotDeleteMsgTitle" : "Nie można usunąć konta",
    "cannotDeleteMsg1" : "Twoje konto nie spełnia wymagań do usunięcia:",
    "cannotDeleteMsg2" : "Masz nierozwiązane zgłoszenia do wsparcia. Proszę je rozwiązać przed ponownym złożeniem wniosku.",
    "cannotDeleteMsg3" : "Masz zaległe zwroty. Proszę je uregulować przed złożeniem wniosku o usunięcie konta.",
    "cannotDeleteMsg4" : "Twoje konto jest obecnie w trakcie przeglądu z powodu zgłoszeń lub skarg graczy. Proszę poczekać na zakończenie przeglądu przed ponownym złożeniem wniosku.",
    "formCompleted" : "Zgłoszenie wysłane",
    "formCheckMsg1" : "Twoje zgłoszenie zostało przesłane, proszę czekać na przegląd i odpowiedź.",
    "formCheckMsg2" : "Możesz sprawdzić postęp zgłoszenia w <span class=\"account-delete-link\">[Moje Zgłoszenia]</span>.",
    "delEmailMsg1" : "Powiadomić Cię e-mailem po usunięciu?",
    "delEmailMsg2" : "Usunięcie konta zajmie około tygodnia z powodu przetwarzania danych. Czy chcesz otrzymać powiadomienie e-mail po zakończeniu?",
    "delEmailMsg3" : "Twój adres e-mail będzie używany wyłącznie do celów powiadomień.",
    "delEmailConfirmYes" : "Tak, proszę powiadomić mnie e-mailem.",
    "delEmailFill" : "Proszę podać swój adres e-mail do powiadomień.",
    "delEmailConfirmNo" : "Nie, nie potrzebuję powiadomienia e-mail.",
    "delCoolMsg1" : "Czy chciałbyś skorzystać z 14-dniowego okresu karencji?",
    "delCoolMsg2" : "W trakcie 14-dniowego okresu karencji Twoje konto zostanie zamrożone, jednak w tym czasie możesz złożyć wniosek o anulowanie procesu usunięcia konta. Po upływie 14 dni, jeśli nie zdecydujesz się na anulowanie, Twoje konto zostanie trwale usunięte i nie będzie możliwości jego odzyskania.",
    "delCoolMsg3" : "Jeśli zdecydujesz się nie korzystać z okresu karencji, Twoje konto zostanie natychmiast trwale usunięte po zakończeniu procesu wnioskowania i nie będzie możliwości jego odzyskania.",
    "delCoolConfirmYes" : "Tak, chcę skorzystać z 14-dniowego okresu karencji.",
    "delCoolConfirmNo" : "Nie, usuń konto natychmiast.",
    "delSecondCheckMsg1" : "Czy na pewno zakończyłeś zarządzanie wszystkimi treściami konta i chcesz aktywować okres karencji? Twoje konto stanie się niedostępne po aktywacji.",
    "delSecondCheckConfirmYes" : "Tak, aktywuj teraz.",
    "delResMsg1" : "Twoja prośba o usunięcie konta została złożona, a poniższe konto zostało zamrożone:",
    "gameName" : "Nazwa gry:",
    "gameAccount" : "Konto gry:",
    "delResMsg2" : "<span>Proszę wykonać zrzut ekranu i zapisać powyższe informacje o koncie, ponieważ stanowią one jedyne potwierdzenie, jeśli będziesz potrzebować przywrócić konto podczas okresu karencji</span>.",
    "delResMsg3" : "Okres karencji: 14 dni. Pozostały czas:",
    "delResMsg4" : "Aby anulować prośbę o usunięcie konta podczas okresu karencji, kliknij [Skontaktuj się z pomocą techniczną].",
    "copyAccountInfo" : "Kopiuj informacje o koncie",
    "delResMsg5" : "Twoja prośba o usunięcie konta została przetworzona, a Twoje konto jest obecnie usuwane. W związku z tym nie możesz się już na nie zalogować.",
    "delResMsg6" : "Ze względu na dużą ilość danych związanych z usunięciem konta proces ten zajmie trochę czasu. W związku z tym wszystkie ślady Twojego konta nie zostaną usunięte natychmiast. Oczekujemy, że proces ten zakończy się w ciągu około tygodnia.",
    "delResMsg7" : "Jeśli wcześniej podałeś adres e-mail do powiadomień, wyślemy na niego stosowne powiadomienie.",
    "delResMsg8" : "Jeśli chcesz ponownie zalogować się do gry, możesz zarejestrować nowe konto.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Inne kanały",
    "itemWrong" : "Wystąpił błąd w Twoim wpisie. Proszę spróbować ponownie.",
    "delRegisterTime" : "Data Rejestracji",
    "delDevice" : "Najczęściej używane urządzenie",
    "delIp" : "Często używany adres IP",
    "delHistoryPayChannel" : "Kanały historycznych doładowań",
    "delHistoryPayOrder" : "Numery poprzednich zamówień",
    "delDeleteReason" : "Powód usunięcia konta",
    "delPrevStep" : "Poprzedni",
    "delNextStep" : "Następny",
    "delSecondCheckMsg2" : "Czy na pewno udało Ci się uporządkować zawartość konta i chcesz kontynuować jego usunięcie? Po wykonaniu tej operacji dostęp do konta nie będzie już możliwy.",
    "pleaseFillIn" : "Podaj następujące informacje",
    "switchNewVersion": "Przejdź na nową ",
    "switchNewVersionPlatform": "platformę płatności",
    "updateVersionPopupContent": "Aby zapewnić płynną wydajność gry oraz wsparcie dla przyszłych nowych funkcji, zalecamy aktualizację systemu urządzenia, aby cieszyć się bardziej stabilnym działaniem i optymalizacją kompatybilności.",
    selectTopupTips: "90% użytkowników wybiera oficjalne centrum doładowań",
    chuzhi: "Doładowanie",
    selectMethods: "Metoda płatności",
    landscapeTip2: "Proszę obrócić telefon w tryb pionowy, aby uzyskać lepsze wrażenia",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox'
}